import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, OnInit, OnDestroy, Output, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LoaderService } from '@app/core/services/loader/loader.service';
import { CategoryFilterModel, FilterList, FilterModel, ProductAdditionalInfoModel, ProductList, SubCategoryFilterModel } from '@app/shared/models/product';
import { ErrorhandlerService } from '@app/shared/services/errorhandler/errorhandler.service';
import { ProductService } from '@app/shared/services/product/product.service';
import { environment } from '@env/environment';
import { InksofteditorInterfaceData } from '@app/shared/components/inksofteditor/inksofteditor.interface';
import { Router, ActivatedRoute } from '@angular/router';
import { LocalStorageService } from '@app/core/services/localStorage/local-storage.service';
import { MatDialog } from '@angular/material/dialog';
import { UploadFileComponent } from '@app/shared/dialogs/upload-file/upload-file.component';
import { StateService } from '@app/shared/services/state/state.service';
import { FilterComponent } from '@app/shared/components/filter/filter.component';
import { PopupService } from '../../../services/popup/popup.service';
import { UploadShipcostFileComponent } from '@app/shared/dialogs/upload-shipcost-file/upload-shipcost-file.component';
import { HttpClient } from '@angular/common/http';
import { DesignListComponent } from '../design-list/design-list.component';
import { ProjectTitlesDialogComponent, toDesignHuddleProjectTitle } from '../project-titles-dialog/project-titles-dialog.component';
import { DesignHuddleService } from '@app/shared/services/design-huddle/design-huddle.service';
import { PdfThumbnailService } from '@app/shared/services/pdfThumbnail/pdf-thumbnail.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ProductImageMatteService } from '@app/shared/services/design-huddle/product-image-matte.service';
import { DesignHuddleUploadOverrideService } from '@app/shared/services/design-huddle/design-huddle-upload-override.service';
import { getRoutePrefix } from '@app/shared/utils/route-prefix.util';
import { timeout, catchError, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { ImpressDecorationLocationCodeService } from '@app/feature/super-admin/services/impress-decoration-location-code.service';
import { DecorationTypeService } from '@app/shared/services/decoration-type.service';
import { ProductDecoration } from '@app/shared/models/decoration-type.model';


@Component({
  selector: 'app-master-product-listing',
  templateUrl: './master-product-listing.component.html',
  styleUrls: ['./master-product-listing.component.css']
})
export class MasterProductListingComponent implements OnInit, AfterViewInit, OnDestroy {
  mobileScreen: boolean = false;
  searchString: string;
  searchForm !: FormGroup;
  filterList !: FilterList;
  filterModel !: FilterModel;
  productList: ProductList[] = [];
  productCount: number;
  productTotalCount: number;
  isDisplay = 'none';
  isDisableFilterBtn = true;
  pageSize = 20; // No of items to load from server side i.e no of items to take
  masterProductImgBaseURL: string;
  throttle = 100;
  scrollDistance = 0;
  isFullListDisplayed = false;
  scrolling = false;
  pageIndex = 0;
  downloadFileUrl: string;
  downloadShipCostFile: string;
  Categories: SubCategoryFilterModel[];
  categoryHeader: string;

  selectProduct: InksofteditorInterfaceData | null = null;
  @Output() ProductData = new EventEmitter<InksofteditorInterfaceData>();

  // Side thumbnails + per-side print-location dropdown shown per card (visual selector only —
  // see getRegionChips()/selectSideLocation() below for why this doesn't touch TemplateId).
  // Explicit active-region state, set the instant a thumbnail is clicked — NOT derived from the
  // currently displayed preview image. It used to be derived that way, but the preview image only
  // updates once the async DesignHuddle preview call finishes (or the SDK isn't loaded and never
  // calls back), so the active-thumbnail highlight used to sit frozen on the old side until that
  // finished. Falls back to deriving from the current image only before any thumbnail has ever
  // been explicitly clicked (initial render).
  readonly cardRegions: string[] = ['Front', 'Back', 'Left', 'Right'];
  decorationLocationCodes: any[] = [];
  private cardActiveRegion: { [productId: string]: string } = {};
  // Keyed by sideLocationKey() (`${productId}_${region}`), NOT just productId — every side shows
  // its own placement dropdown simultaneously now, so each side's pick has to persist
  // independently instead of one shared "current location" per product.
  private cardSubLocation: { [key: string]: number } = {};

  // Which product+region's custom location dropdown is open (sideLocationKey()) — null when none.
  // A custom dropdown (not a native <select>) so it can be styled translucent and kept at a
  // z-index below the fixed footer bar, instead of a native popup that always renders above
  // everything regardless of CSS.
  openLocationDropdownKey: string | null = null;

  listPanels = {
    category: true,
    product: false
  };
  PageClass: string;
  isAddProductPage = false;
  isBrowseOnly = false;
  // Local storage fields
  userRole: any;
  @ViewChild(FilterComponent) filterComp: FilterComponent;
  @ViewChild('productListContainer') productListContainer: ElementRef<HTMLElement>;
  @ViewChildren('productCard') productCards: QueryList<ElementRef>;
  private lastCardObserver: IntersectionObserver | null = null;
  screenPrint: boolean = true;
  embroidery: boolean = true;
  productImageLists: Map<string, string[]> = new Map(); // Store image arrays for each product
  productCurrentImages: Map<string, string> = new Map(); // Track current main image for each product

  // Design and product selection
  designData: any = null;
  // Image bound by the "Your Design" banner. For a PDF design this is page 1 rasterized to a PNG
  // data URL — a browser cannot decode a PDF inside an <img> and would show a broken image.
  designBannerSrc: string | null = null;
  // True while that rasterization is in flight.
  isRenderingDesignBanner: boolean = false;
  selectedProducts: Set<string> = new Set();
  selectedProductsCount: number = 0;
  selectedProductsDataMap: Map<string, any> = new Map();
  storeId: number;
  storeName: string;

  // DesignHuddle integration
  designHuddleTemplates: any[] = [];
  isLoadingTemplates: boolean = false;
  generatedPreviews: Map<string, string> = new Map(); // Cache: productId_sideName -> preview URL
  loadingPreviews: Set<string> = new Set(); // Track which products are generating previews
  originalImageUrls: Map<string, string> = new Map(); // Map: productId_sideName -> original image URL
  productTemplateIds: Map<string, number> = new Map(); // Map: productId -> template_id
  productSideNames: Map<string, string> = new Map(); // Map: productId -> sideName (used for project creation)
  showDesignHuddleEditorModal = false;
  isCreatingProject = false;
  editorProductName = '';
  currentEditorProjectId: string | null = null;
  currentEditorProductId: string | null = null;
  currentEditorSideName: string | null = null;
  currentEditorProjectTitle: string | null = null;
  projectMetadata: any = null;
  isFetchingProjectData: boolean = false;
  // Live DesignHuddle editor instance (from Editors.insert callback). Must be .remove()'d on close
  // to deregister it from the SDK registry — the SDK keys registration by this instance's own id,
  // NOT by container id or project id, so Editors.remove(containerId) does NOT free the project.
  // Without this, reopening the same project's editor (e.g. later on color-selection) fails with
  // "Only one Editor can be active per Project ID".
  dhEditorInstance: any = null;
  // Text-element export flag: set when the last closed editor project contained text elements.
  // Carried forward to color-selection via state so the export-API path is used on that page too.
  currentProjectHasTextElements: boolean = false;
  // Map: "productId_sideName" -> { projectId, elementPlacement, zonePlacement }
  editorSideData: Map<string, any> = new Map();
  // Counter for export-API previews currently in flight (used to disable the Continue button).
  exportPreviewsInFlight: number = 0;

  // Product request mode — when launched from /superadmin/product-requests
  isProductRequestMode: boolean = false;
  productRequestData: any = null;
  private productRequestAutoAdvanced: boolean = false;
  // Guards against firing GetProductList twice — see ngOnInit's parallel-fetch note and the
  // matching check in fn_GetFilters()'s designData branch.
  private designDataProductsAlreadyFetched: boolean = false;

  constructor(private loader: LoaderService,
    private router: Router,
    private route: ActivatedRoute,
    private productservice: ProductService,
    private errorhandlerService: ErrorhandlerService,
    private formBuilder: FormBuilder,
    private localstorageService: LocalStorageService,
    private dialog: MatDialog,
    private stateService: StateService,
    private popupService: PopupService,
    private http: HttpClient,
    private designHuddleService: DesignHuddleService,
    private pdfThumbnail: PdfThumbnailService,
    private commonService: CommonService,
    private productImageMatteService: ProductImageMatteService,
    private uploadOverride: DesignHuddleUploadOverrideService,
    private decorationLocationCodeService: ImpressDecorationLocationCodeService,
    private decorationTypeService: DecorationTypeService) {
      // Make component accessible from browser console for debugging
      (window as any).productListingComponent = this;

      // Subscribe to query params
      this.route.queryParams.subscribe(params => {
        this.storeId = params['storeId'] || localStorage.getItem('storeId');
        this.storeName = params['storeName'] || localStorage.getItem('storeName') || '';
      });
    }

  ngOnInit() {
    this.isAddProductPage = !this.router.url.includes('masterproducts');
    this.PageClass = !this.isAddProductPage ? 'content-blk' : '';
    this.userRole = this.localstorageService.get('role');

    // Detect product request mode (launched from /superadmin/product-requests)
    const prMode = this.stateService.getProductRequestMode();
    if (prMode && prMode.isProductRequestMode) {
      this.isProductRequestMode = true;
      this.productRequestData = prMode;

      // Clear all local caches so a new product request starts fresh
      this.selectedProducts.clear();
      this.selectedProductsDataMap.clear();
      this.selectedProductsCount = 0;
      this.productImageLists.clear();
      this.productCurrentImages.clear();
      this.productTemplateIds.clear();
      this.productSideNames.clear();
      this.editorSideData.clear();
      this.loadingPreviews.clear();
      this.cardActiveRegion = {};
      this.cardSubLocation = {};
      this.stagedColorways = {};
      this.defaultStagedStyleId = {};
      this.expandedColorwaySwatches.clear();
      this.stateService.clearStagedColorwayState();
      this.productRequestAutoAdvanced = false;
    }

    this.initialize();
    this.fn_GetFilters();
    this.loadDecorationLocationCodes();

    // Browse-only mode: skip design flow when viewing All Products
    // BUT if design data exists in state, we're in the add product flow (not browse-only)
    const hasDesignData = !!this.stateService.getDesignData() || !!this.stateService.getDesignDataForProduct();
    if (!this.isAddProductPage && !hasDesignData) {
      this.isBrowseOnly = true;
    }

    // Initialize DesignHuddle SDK (skip in browse-only mode)
    if (!this.isBrowseOnly) {
      this.initializeDesignHuddle();

      // Load design data from state service if available
      this.loadDesignDataFromState();
    }

    // Fire GetProductList in parallel with GetFilters (line above) instead of waiting for it —
    // this branch (design flow, no saved filter to restore) never reads anything from the
    // filters response, so nesting it inside fn_GetFilters()'s subscribe callback only added an
    // unnecessary serial round-trip (GetProductList wouldn't even start until GetFilters's
    // network response came back). fn_GetFilters()'s matching branch checks
    // designDataProductsAlreadyFetched so this doesn't fire twice. The other branch in
    // fn_GetFilters() (a saved filter to restore) genuinely needs filterList.Categories from
    // that response first, so it's left as-is.
    const hasSavedFilterToRestore = !this.isBrowseOnly && !!this.localstorageService.get('masterproductfilter');
    if (!hasSavedFilterToRestore && this.designData) {
      this.nextPanel(this.propName(this.listPanels, this.listPanels.product));
      this.fn_GetProducts();
      this.designDataProductsAlreadyFetched = true;
    }

    // In product request mode, skip the category/browse UI and load only the
    // requested product. DesignHuddle previews run automatically after load.
    if (this.isProductRequestMode && this.productRequestData?.productId) {
      this.listPanels.category = false;
      this.listPanels.product = true;
      this.loadProductForRequest(Number(this.productRequestData.productId));
    }

    this.mobileScreen = $(window).width() >= 768 ? false : true;
  }

  ngOnDestroy(): void {
    // Safety net: if the user navigates away before preview generation completes,
    // clear the persistent message so it cannot bleed into the next page load.
    this.loader.clearPersistentMessage();
    this.lastCardObserver?.disconnect();
    this.lastCardObserver = null;

    // Safeguard: if the user navigates away with the DesignHuddle editor still open (without
    // clicking close), deregister the editor instance so its project ID is freed. Otherwise the
    // next page (e.g. color-selection) hits "Only one Editor can be active per Project ID".
    if (this.dhEditorInstance && typeof this.dhEditorInstance.remove === 'function') {
      try {
        this.dhEditorInstance.remove();
      } catch (e) { /* non-fatal */ }
    }
    this.dhEditorInstance = null;
  }

  ngAfterViewInit(): void {
    // Set up the IntersectionObserver once the view is initialised.
    // The product list panel scrolls inside .panel-step (height: 80vh), so use
    // that element as the observer root rather than the viewport.
    this.setupLastCardObserver();

    // Re-observe whenever the QueryList changes (new batch of cards rendered).
    this.productCards.changes.subscribe(() => {
      this.observeLastCard();
    });
  }

  private setupLastCardObserver(): void {
    // Disconnect any previous observer first.
    this.lastCardObserver?.disconnect();

    // The .panel-step element has height: 80vh but NO overflow-y set, so content
    // overflows and the WINDOW scrolls — not the panel element.  Using
    // productListContainer as root would mean the observer never fires because the
    // card and the root scroll container are the same element and there is no
    // relative motion between them.  root: null means the viewport (window).
    // rootMargin fires the callback 200px before the last card's bottom edge
    // reaches the viewport bottom so the next batch loads before the user hits
    // the absolute end of the list.
    this.lastCardObserver = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            // Unobserve immediately so the callback does not fire again for
            // the same card while the next batch is loading.
            this.lastCardObserver?.unobserve(entry.target);
            this.fn_GetProducts_Scroll();
            break;
          }
        }
      },
      { root: null, rootMargin: '0px 0px 200px 0px', threshold: 0 }
    );

    // Observe current last card if one already exists (e.g. after a filter reset).
    this.observeLastCard();
  }

  private observeLastCard(): void {
    if (!this.lastCardObserver) return;

    // Always unobserve everything first so we only ever watch the latest last card.
    this.lastCardObserver.disconnect();

    if (this.isFullListDisplayed) return;

    const cards = this.productCards.toArray();
    if (cards.length === 0) return;

    const lastCard = cards[cards.length - 1];
    this.lastCardObserver.observe(lastCard.nativeElement);
  }

  /**
   * Product request mode: reuse the normal fn_GetProducts pipeline with a ProductIds
   * filter so the product is built via the exact same code path (and data shape) as
   * the normal browse-a-category flow. Post-processing (override locked color,
   * auto-select, auto-advance) happens in fn_GetProducts via the PR-mode hook.
   */
  loadProductForRequest(productId: number): void {
    this.filterModel.ProductIds = [productId];
    this.filterModel.Skip = 0;
    this.filterModel.Take = 1;
    this.fn_ResetProductList();
    this.fn_GetProducts();
  }

  /**
   * Product request mode post-hook (called from fn_GetProducts after productList is
   * populated): override the default style on the loaded product to the first
   * customer-requested color, regenerate its image list for that color, and
   * auto-select it. The standard preview pipeline then runs against the locked color.
   */
  private applyProductRequestLock(): void {
    const product = this.productList[0];
    if (!product) return;

    // Find the requested style (by UniqueStyleId) on the loaded product
    const requestedStyles: any[] = this.productRequestData?.requestedStyles || [];
    let lockedStyle: any = null;
    for (const req of requestedStyles) {
      const match = (product as any).Styles?.find((s: any) => String(s.ID) === String(req.ID || req.StyleId));
      if (match) {
        lockedStyle = match;
        break;
      }
    }

    // Fallback to the current default style (already set by fn_GetProducts)
    if (!lockedStyle) {
      lockedStyle = (product as any).Styles?.find((s: any) => s.ID === (product as any).StyleId);
    }
    if (!lockedStyle) {
      console.warn('⚠️ applyProductRequestLock: no locked style found for product', product.ProductId);
      return;
    }

    // IMPORTANT: productImageLists / productCurrentImages are keyed by the raw
    // product.ProductId (number) in fn_GetProducts and generatePreviewForProduct.
    // Must use the same key type here, NOT String(), or the DH preview pipeline
    // will read the old default-color images and show a broken background.
    const imageKey = product.ProductId;
    const pidStrKey = String(product.ProductId);

    // Rebuild image list for the locked color
    const imageList: string[] = [];
    if (lockedStyle.ImageFilePath_Front) imageList.push(this.resolveProductImageUrl(lockedStyle.ImageFilePath_Front));
    if (lockedStyle.ImageFilePath_Back) imageList.push(this.resolveProductImageUrl(lockedStyle.ImageFilePath_Back));
    if (lockedStyle.ImageFilePath_SleeveLeft) imageList.push(this.resolveProductImageUrl(lockedStyle.ImageFilePath_SleeveLeft));
    if (lockedStyle.ImageFilePath_SleeveRight) imageList.push(this.resolveProductImageUrl(lockedStyle.ImageFilePath_SleeveRight));

    if (imageList.length > 0) {
      // Use the raw productId (number) key to match fn_GetProducts
      this.productImageLists.set(imageKey as any, imageList);
      this.productCurrentImages.set(imageKey as any, imageList[0]);
    }

    // Override StyleId and visible thumbnail so fn_StyleAttribute-based rendering
    // and generatePreviewForProduct pick the locked color.
    (product as any).StyleId = lockedStyle.ID;
    if (lockedStyle.ImageFilePath_Front) {
      (product as any).ImageUrl = this.resolveProductImageUrl(lockedStyle.ImageFilePath_Front);
    }

    // selectedProducts / selectedProductsDataMap are keyed by String() in
    // toggleProductSelection, so we match that convention here.
    this.selectedProducts.add(pidStrKey);
    this.selectedProductsDataMap.set(pidStrKey, { ...product });
    this.selectedProductsCount = 1;
    this.stateService.setSelectedProductsForDesign([pidStrKey]);

    console.log('🔒 PR mode: locked color', {
      productId: product.ProductId,
      lockedStyleId: lockedStyle.ID,
      styleName: lockedStyle.Name,
      imageListSize: imageList.length,
      firstImage: imageList[0]
    });
  }

  /**
   * Product request mode: after DesignHuddle preview generation completes for the
   * single requested product, automatically run the continue step (bypassing the
   * project-title dialog) so the designer lands directly on product-color-selection.
   */
  /**
   * Product request mode: auto-advance is disabled — the designer stays on
   * master-products page to interact normally (select color, view sides, edit
   * design) and clicks Continue when ready.
   */
  private maybeAutoAdvanceForProductRequest(): void {
    // No-op: let the designer use the normal flow
    return;
  }

  loadDesignDataFromState(): void {
    console.log('🔍 Checking for design data in state service...');

    // Check both methods - getDesignData() and getDesignDataForProduct()
    let savedDesignData = this.stateService.getDesignData();

    if (!savedDesignData) {
      savedDesignData = this.stateService.getDesignDataForProduct();
      if (savedDesignData) {
        // Set it in both locations for consistency
        this.stateService.setDesignData(savedDesignData);
      }
    }

    if (savedDesignData) {
      this.designData = savedDesignData;
      console.log('✅ Design data loaded:', this.designData);

      this.prepareDesignBannerThumbnail();

      // Wait for products to load, then generate previews
      // (skip in product request mode — preview runs after applyProductRequestLock)
      if (!this.isProductRequestMode) {
        setTimeout(() => {
          if (this.productList.length > 0) {
            console.log('🎨 Generating DesignHuddle previews for all products...');
            // designData.designUrl/previewUrl can still point at a raw .pdf for designs saved
            // before upload-time PDF conversion existed (or uploaded via a path that never
            // converts, e.g. the store-admin uploader). DSHDLib.getVariableTemplatePreviewURL
            // takes that URL verbatim as the logo media, and Design Huddle rasterizes a PDF onto
            // an opaque page canvas — the mockup then shows a solid box behind the logo instead
            // of a transparent cutout. Convert to a transparent PNG first, same as
            // design-preview.component.ts's convertPdfDesignToImage.
            this.convertLegacyPdfDesignToImage().then(() => {
              this.generatePreviewsForAllProducts();
            });
          }
        }, 2000);
      }
    } else {
      console.log('ℹ️ No design data found — redirecting to upload-design');
      this.goToUploadDesign();
      return;
    }

    // Load selected products from state (skip in product request mode —
    // applyProductRequestLock handles selection after products load)
    if (!this.isProductRequestMode) {
      const savedSelectedProducts = this.stateService.getSelectedProductsForDesign();
      if (savedSelectedProducts && Array.isArray(savedSelectedProducts)) {
        this.selectedProducts = new Set(savedSelectedProducts);
        this.selectedProductsCount = this.selectedProducts.size;
        console.log('✅ Selected products loaded:', this.selectedProducts);
      }
      this.restoreBuildState();
    }
  }

  // Resolves the image the "Your Design" banner shows. Images bind directly; a PDF is rasterized
  // to a PNG first, since a browser cannot decode a PDF inside an <img>. A PDF that fails to
  // render leaves designBannerSrc null and the banner falls back to its file-type tile.
  private prepareDesignBannerThumbnail(): void {
    const source = this.designData?.previewUrl || this.designData?.designUrl || '';

    if (!this.pdfThumbnail.isPdfUrl(source)) {
      this.designBannerSrc = source || 'assets/img/default-design.png';
      this.isRenderingDesignBanner = false;
      return;
    }

    this.designBannerSrc = null;
    this.isRenderingDesignBanner = true;

    // The banner thumbnail is ~60px; 200px keeps it sharp on a 2x display.
    this.pdfThumbnail.render(source, 200).then((dataUrl) => {
      this.isRenderingDesignBanner = false;
      this.designBannerSrc = dataUrl;
    });
  }

  /**
   * Re-uploads a legacy PDF-backed design as a transparent PNG and repoints designData at it.
   *
   * Resolves to true immediately (no-op) when designData isn't a PDF. On successful conversion,
   * updates designData.designUrl/previewUrl/logoUrl/fileName in place and writes the result back
   * to state, so every consumer on this page (DSHDLib preview calls, the "Your Design" banner,
   * and any later navigation) reads the converted PNG instead of the raw PDF from then on.
   *
   * The upload endpoint names blobs by content hash, so converting the same design twice reuses
   * the existing blob rather than filling storage with duplicates.
   */
  private convertLegacyPdfDesignToImage(): Promise<boolean> {
    const source = this.designData?.previewUrl || this.designData?.designUrl || '';
    if (!this.pdfThumbnail.isPdfUrl(source)) { return Promise.resolve(true); }

    this.loader.setPersistentMessage('Converting PDF design to image');
    this.loader.show();

    return this.pdfThumbnail.rasterizePdfUrl(source)
      .then((dataUrl) => {
        if (!dataUrl) { return false; }

        return this.commonService
          .uploadHuddleLogo({ File: dataUrl.split(',')[1], Extension: 'png' })
          .toPromise()
          .then((response: any) => {
            if (!response || response.StatusCode !== 200) { return false; }

            const fileName = response.Data.ResponseData;
            const convertedUrl = environment.huddleLogoFolder + fileName;

            this.designData = {
              ...this.designData,
              logoUrl: convertedUrl,
              previewUrl: convertedUrl,
              designUrl: convertedUrl,
              fileName
            };

            // Repoint saved state at the converted PNG too, so navigating back to this page (or
            // on to color-selection) never re-hits the raw PDF again.
            this.stateService.setDesignData(this.designData);
            this.stateService.setDesignDataForProduct(this.designData);

            return true;
          });
      })
      .catch(() => false)
      .then((ok) => {
        this.loader.clearPersistentMessage();
        this.loader.hide();
        if (!ok) {
          console.error('❌ Failed to convert legacy PDF design to image — product mockups will render with an opaque background behind the logo.');
        }
        return ok;
      });
  }

  initialize() {

    this.masterProductImgBaseURL = environment.masterProductImgBaseURL;
    this.categoryHeader = "Browse by Categories";
    this.productList = [];
    this.productCount = 0;
    this.isFullListDisplayed = false;
    this.scrolling = false;
    this.pageIndex = 0;
    this.filterModel = {
      Skip: 0,
      Take: this.pageSize,
      Size: [],
      Brand: [],
      Color: [],
      DecorationLocationCodeId: [],
      InkSoftUserId: 0,
      searchBy: '',
      Category: ''
    };
    this.filterList = {
      Categories: [],
      Brands: [],
      Colors: [],
      Sizes: [],
      PrintLocations: []
    };
    this.searchForm = this.formBuilder.group({
      searchProduct: ['']
    });
  }
  fn_downloadProductFeatures() {
    this.loader.show();
    this.productservice.downloadProductFeatures().subscribe((blob: Blob) => {
      this.loader.hide();
      const downloadLink = document.createElement("a");
      const url = window.URL.createObjectURL(blob);

      downloadLink.href = url;
      downloadLink.download = 'ProductFeatures.xlsx'; // File name
      downloadLink.click();

      // Clean up the object URL
      window.URL.revokeObjectURL(url);
    }, (err: any) => {
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  // fn_downloadShipCost() {
  //   this.loader.show();
  //   this.productservice.downloadShipCost().subscribe((blob: Blob) => {
  //     this.loader.hide();
  //     const downloadLink = document.createElement("a");
  //     const url = window.URL.createObjectURL(blob);
  //
  //     downloadLink.href = url;
  //     downloadLink.download = 'ShipCostInfo.xlsx'; // File name
  //     downloadLink.click();
  //
  //     // Clean up the object URL
  //     window.URL.revokeObjectURL(url);
  //   }, (err: any) => {
  //     this.loader.hide();
  //     this.errorhandlerService.handleError(err);
  //   });
  // }

  fn_GetProducts_Scroll() {
    if (!this.scrolling && !this.isFullListDisplayed) {
      this.scrolling = true;
      this.filterModel.Skip = this.pageSize * this.pageIndex;
      this.fn_GetProducts();
    }
  }

  fn_GetProducts() {
    this.loader.show();
    this.scrolling = true;
    this.fn_EnableDisableResetFilterBtn();
    this.filterModel.UserId = Number(localStorage.getItem('userId'));
    this.filterModel.ScreenPrint = localStorage.getItem("screenprint") == undefined ? this.screenPrint : localStorage.getItem("screenprint") == "true" ? true : false;
    this.filterModel.Embroidery = localStorage.getItem("embroidery") == undefined ? this.screenPrint : localStorage.getItem("embroidery") == "true" ? true : false;
    // Only the design-build flow (region tabs + per-side location dropdowns, gated by
    // *ngIf="designData" in the template) ever reads Side.TemplatePlacements — skip fetching it
    // for a plain browse (no designData) so the backend can skip its extra Sides ->
    // SideTemplatePlacements -> ImpressDecorationLocationCode join/round-trip.
    this.filterModel.IncludeTemplatePlacements = !!this.designData;
    this.productservice.getAllProducts(this.filterModel).subscribe((res: any) => {
      this.loader.hide();
      if (res.Message === 'Success' || res.StatusCode === 200) {
        if (res.Data.ProductList.length > 0) {
          // save filter (skip saving product-request filters that restrict to a single product)
          if (!this.filterModel.ProductIds || this.filterModel.ProductIds.length === 0) {
            this.localstorageService.set('masterproductfilter', JSON.stringify(this.filterModel));
          }
          this.productTotalCount = res.Data.TotalDataCount;

          for (let i = 0; i < res.Data.ProductList.length; i++) {
            // check if item with same id does not exists
            if (!this.productList.find(x => x.ProductId === res.Data.ProductList[i].ID)) {
              const getStyleAttributes = this.fn_StyleAttribute(res.Data.ProductList[i].Styles, res.Data.ProductList[i].DefaultStyleId);
              const lowestUnitPrice = this.fn_FetchLowestUnitPrice(res.Data.ProductList[i].Styles);
              var activeStyles = res.Data.ProductList[i].Styles.filter(i => i.IsActive == true);

              const productId = res.Data.ProductList[i].ID;

              // Build image list for this product from default style (fall back to first active style)
              const defaultStyle = (res.Data.ProductList[i].DefaultStyleId
                ? res.Data.ProductList[i].Styles.find(s => s.ID == res.Data.ProductList[i].DefaultStyleId)
                : null) || res.Data.ProductList[i].Styles.find(s => s.IsActive) || res.Data.ProductList[i].Styles[0];
              if (defaultStyle) {
                const imageList = [];
                if (defaultStyle.ImageFilePath_Front) {
                  imageList.push(this.resolveProductImageUrl(defaultStyle.ImageFilePath_Front));
                }
                if (defaultStyle.ImageFilePath_Back) {
                  imageList.push(this.resolveProductImageUrl(defaultStyle.ImageFilePath_Back));
                }
                if (defaultStyle.ImageFilePath_SleeveLeft) {
                  imageList.push(this.resolveProductImageUrl(defaultStyle.ImageFilePath_SleeveLeft));
                }
                if (defaultStyle.ImageFilePath_SleeveRight) {
                  imageList.push(this.resolveProductImageUrl(defaultStyle.ImageFilePath_SleeveRight));
                }
                this.productImageLists.set(productId, imageList);
                // Set first image as current
                if (imageList.length > 0) {
                  this.productCurrentImages.set(productId, imageList[0]);
                }
              }

              // Bug fix: StyleId must reference a style present in `activeStyles` (what we store in
              // product.Styles). DefaultStyleId is frequently NULL (never back-filled for existing
              // products) or points at an inactive style, so generatePreviewForProduct()'s
              // `s.ID === product.StyleId` lookup returns undefined ("Current style not found") and
              // the DH preview is skipped. Match DefaultStyleId loosely against the active styles,
              // else fall back to the first active style. (DefaultStyleId and style.ID are both
              // ParseInt(UniqueStyleId), so this matches by value.)
              const defaultStyleId = res.Data.ProductList[i].DefaultStyleId;
              const resolvedActiveStyle = activeStyles.find((s: any) => s.ID == defaultStyleId) || activeStyles[0];
              const resolvedStyleId = resolvedActiveStyle ? resolvedActiveStyle.ID : defaultStyleId;

              this.productCount = this.productList.push({
                ProductId: productId,
                CategoryId: res.Data.ProductList[i].CategoryUniqueId,
                StyleId: resolvedStyleId,
                Description: res.Data.ProductList[i].Name,
                DesignId: '',
                Styles: activeStyles,
                ImageUrl: getStyleAttributes.ImageUrl,
                // UnitCost: getStyleAttributes.UnitCost,
                UnitCost: lowestUnitPrice,
                Sizes: getStyleAttributes.Sizes,
                IsActive: res.Data.ProductList[i].IsActive,
                ProductAdditionalInfo: res.Data.ProductList[i].ProductAdditionalInfo,
                CustomizationType: res.Data.ProductList[i].CustomizationType,
                Sides: res.Data.ProductList[i].Sides || [], // Include Sides data from API
                LongDescription: res.Data.ProductList[i].LongDescription || ''
              });
            }
          }
          // WI 1378 — load per-product decoration options for the design-build cards
          if (this.designData) {
            this.loadProductDecorations();
          }

          if (res.Data.ProductList.length < this.pageSize) {
            this.isFullListDisplayed = true;
          }
          this.pageIndex++;
          this.scrolling = false;

          setTimeout(function () { $(".content-blk").css("min-height", $(document).height()); }, 100)

          // Product request mode post-hook: override the default style to the first
          // requested color, auto-select the product, and let the standard preview
          // pipeline take over. Must run before generatePreviewsForAllProducts so
          // the initial preview is generated for the locked color.
          if (this.isProductRequestMode && this.productRequestData && this.productList.length > 0) {
            this.applyProductRequestLock();
          }

        } else if (res.Data.ProductList.length === 0) {
          this.isFullListDisplayed = true;
          this.scrolling = false;
        }
        this.isDisplay = this.productCount > 0 ? 'none' : 'block';

        // Generate DesignHuddle previews after products are loaded (for search results).
        // BUG 2 FIX: set the persistent message and re-show the loader BEFORE the
        // setTimeout so that the loader.hide() at the top of this callback (line above
        // the success check) is immediately followed by a show() rather than leaving a
        // ~500 ms gap. Angular batches the hide+show into one render frame, so there
        // is no visible blink. The persistent message suppresses any intermediate
        // hide() calls until previews are done.
        if (this.designData && (this.designData.designUrl || this.designData.previewUrl) && this.productList.length > 0) {
          console.log('🎨 Generating DesignHuddle previews after product search...');
          this.loader.setPersistentMessage('Generating product preview');
          this.loader.show();
          setTimeout(() => {
            this.generatePreviewsForAllProducts();
          }, 500);
        } else {
          // Previews will NOT be generated (no design URL or empty product list).
          // Clear any leftover persistent message and explicitly hide to close the
          // overlay. Order: clear first (so hide() is no longer suppressed), then hide.
          this.loader.clearPersistentMessage();
          this.loader.hide();
        }
      }
    }, (err: any) => {
      this.loader.clearPersistentMessage();
      this.loader.hide();
      this.scrolling = false;
      this.errorhandlerService.handleError(err);
    });
  }

  /** Function to display product color(s) in color selector */
  displayColor(obj: any) {
    if (!obj) return { 'background-color': '#ccc' };
    const color = obj.startsWith('#') ? obj : '#' + obj;
    return {
      'background-color': color
    };
  }
  /** Gets corresponding image to product...using the first style */
  fn_StyleAttribute(styleList: any, defaultStyleId: any) {
    // Find by defaultStyleId, fall back to first active style, then first style
    let styleData = defaultStyleId ? styleList.find(s => s.ID == defaultStyleId) : null;
    if (!styleData) {
      styleData = styleList.find(s => s.IsActive) || styleList[0];
    }

    if (!styleData) {
      return {
        Sizes: [],
        ImageUrl: '',
        UnitCost: 0
      };
    }

    if (!styleData.Sizes || !Array.isArray(styleData.Sizes)) {
      console.error('❌ Sizes not found for style:', styleData);
      return {
        Sizes: [],
        ImageUrl: this.resolveProductImageUrl(styleData.ImageFilePath_Front || ''),
        UnitCost: 0
      };
    }

    const orderBy = styleData.Sizes.sort((a, b) => a.SortOrder - b.SortOrder);
    return {
      Sizes: Array.prototype.map.call(orderBy, function (item) {
        return {
          Name: item.Name,
          LongName: item.LongName
        };
      }),
      ImageUrl: this.resolveProductImageUrl(styleData.ImageFilePath_Front),
      UnitCost: orderBy[0]?.UnitPrice || 0
    };
  }
  // Get the lowest price from all sizes
  fn_FetchLowestUnitPrice(styleList: any) {
    if (!styleList || !Array.isArray(styleList)) {
      console.error('❌ Invalid styleList:', styleList);
      return 0;
    }

    const unitPriceList = styleList.reduce((current, next) => {
      if (next.Sizes && Array.isArray(next.Sizes)) {
        next.Sizes.forEach(size => {
          if (size && size.UnitPrice !== undefined) {
            current.push({
              UnitPrice: size.UnitPrice
            });
          }
        });
      }
      return current;
    }, []);

    if (unitPriceList.length === 0) {
      console.warn('⚠️ No unit prices found');
      return 0;
    }

    const lowestUnitPrice = unitPriceList.sort((a, b) => a.UnitPrice - b.UnitPrice);
    return lowestUnitPrice[0]?.UnitPrice || 0;
  }

  fn_EnableDisableResetFilterBtn() {
    this.isDisableFilterBtn = !(this.filterModel.Size.length > 0 || this.filterModel.Brand.length > 0 ||
      this.filterModel.Color.length > 0 || this.filterModel.Category !== '');
  }
  /** Resets product list */
  fn_ResetProductList() {
    this.productList = [];
    this.productCount = 0;
    this.isFullListDisplayed = false;
    this.scrolling = false;
    this.pageIndex = 0;
  }

  fn_ResetFilter() {
    setTimeout(function () { $(".content-blk").css("min-height", 500) }, 100)
    this.categoryHeader = "Browse by Categories";
    this.localstorageService.remove('masterproductfilter');
    this.filterModel = {
      Skip: 0,
      Take: this.pageSize,
      Size: [],
      Brand: [],
      Color: [],
      DecorationLocationCodeId: [],
      InkSoftUserId: 0,
      searchBy: '',
      Category: ''
    };
    this.searchForm.patchValue({
      searchProduct: ''
    });
    this.nextPanel(this.propName(this.listPanels, this.listPanels.category));
    this.Categories = this.filterList.Categories.map(c => {
      return {
        ...c,
        CoverImage: c.CoverImage
      }
    });
    this.fn_ResetProductList();
  }
  fn_GetFilters() {
    this.filterList.Categories = [];
    this.filterList.Brands = [];
    this.filterList.Colors = [];
    this.filterList.Sizes = [];
    this.filterList.PrintLocations = [];
    this.loader.show();
    this.productservice.getMasterProductFiltersData().subscribe((res: any) => {
      this.loader.hide();
      if (res.Message === 'Success' || res.StatusCode === 200) {
        this.filterList.Categories = this.Categories = res.Data.Categories.map(c => {
          return {
            ...c,
            CoverImage: this.resolveProductImageUrl(c.CoverImage)
          }
        });
        this.filterList.Brands = res.Data.FilterModel.Brands;
        this.filterList.Colors = res.Data.FilterModel.Colors;
        this.filterList.Sizes = res.Data.FilterModel.Sizes;
        this.filterList.PrintLocations = res.Data.FilterModel.PrintLocations || [];

        // Fetch previous filters (only in add-product flow, not browse-only)
        const filter = !this.isBrowseOnly ? this.localstorageService.get('masterproductfilter') : null;
        if (filter) {
          this.filterModel = JSON.parse(filter);
          this.filterModel.Skip = 0;
          this.filterModel.Take = this.pageSize;
          delete this.filterModel.ProductIds;
          this.fn_FetchProducts(this.filterModel.Category);
        } else if (this.designData && !this.designDataProductsAlreadyFetched) {
          // When coming from design flow with no saved filter, load all products.
          // (Usually already fired in parallel from ngOnInit — see
          // designDataProductsAlreadyFetched — this only runs as a fallback for any path that
          // reaches here without having gone through that check, e.g. a future caller.)
          this.nextPanel(this.propName(this.listPanels, this.listPanels.product));
          this.fn_GetProducts();
        }
      }
    }, (err: any) => {
      this.loader.clearPersistentMessage();
      this.loader.hide();
      this.errorhandlerService.handleError(err);
    });
  }

  /**
   * WI 1378 — load the available decoration types for each product card (design-build flow only)
   * so the admin can pick the decoration to design against here; the choice carries into
   * product-color-selection. Only fetches for cards not already loaded (safe across pagination).
   */
  loadProductDecorations(): void {
    const storeId = Number(this.storeId) || undefined;
    this.productList.forEach((product: any) => {
      if (product.decorations) { return; } // already loaded for this card
      const productIdNum = Number(product.ProductId);
      if (!productIdNum) { return; }
      this.decorationTypeService.getProductDecorations(productIdNum, storeId).subscribe({
        next: (decorations: ProductDecoration[]) => {
          product.decorations = decorations || [];
          if (product.selectedDecorationTypeId == null) {
            const def = (decorations || []).find(d => d.IsDefault) || (decorations || [])[0];
            product.selectedDecorationTypeId = def?.DecorationTypeId ?? null;
          }
        },
        error: () => {
          product.decorations = [];
        }
      });
    });
  }

  /** WI 1378 — decoration dropdown change on a master-products card (no ngModel; keeps FormsModule out of this shared component). */
  onCardDecorationChange(product: any, event: any): void {
    const val = event?.target?.value;
    product.selectedDecorationTypeId = (val !== undefined && val !== null && val !== '') ? Number(val) : null;
  }

  /** Opens inksoft editor for customizing a product */
  fn_CustomizeProduct(productid: string, categoryid: string, styleid: string, isCustomise: boolean) {
    if (localStorage.getItem('userId') == null) {
      this.fn_OpenLogin(productid);

    } else {
      if (this.isAddProductPage || isCustomise) {
        this.selectProduct = {
          categoryId: categoryid,
          productId: productid,
          styleId: styleid,
          url: encodeURIComponent('store/iframe-popup?designID=0'),
          designId: '',
          sizes: this.productList.find(x => x.ProductId == productid).Sizes,
          additionalInfo: this.productList.find(x => x.ProductId == productid).ProductAdditionalInfo,
          sizingLabelExist: false,
        };
        if (this.isAddProductPage)
          this.ProductData.emit(this.selectProduct);
        else {
          this.stateService.updateSelectedProduct(this.selectProduct);
          this.router.navigate(['/store/addproduct']);
        }
      }
      else {
        this.gotoDetailPage(productid);
      }
    }
  }


  fn_OpenLogin(productid: string) {
    const productUrl = "masterproduct/detail/" + productid;
    window.localStorage.setItem('urlToRedirect', productUrl);
    this.popupService.openLogin();
  }


  gotoDetailPage(productid: string) {
    if (localStorage.getItem('userId') == null) {
      this.router.navigate(['/masterproduct/detail', productid]);

    } else {
      if (this.userRole == 'SuperAdmin' || this.userRole == 'CustomerService')
        this.router.navigate(['/superadmin/masterproduct/detail', productid]);
      else
        this.router.navigate(['/store/masterproduct/detail', productid]);
    }
  }

  updateProductList(withResetProduct: any) {
    if (withResetProduct.reset) {
      this.fn_ResetFilter();
    }
    else {
      this.filterModel.Skip = 0; // reset Skip so a filter change always starts at page 1
      this.fn_ResetProductList();
      this.screenPrint = withResetProduct.screenPrint;
      this.embroidery = withResetProduct.embroidery;
      // Set persistent message before fetch so text shows from the first frame of the
      // loader — only when previews will be generated.
      if (this.designData && (this.designData.designUrl || this.designData.previewUrl)) {
        this.loader.setPersistentMessage('Generating product preview');
      }
      this.fn_GetProducts();
      this.categoryHeader = this.fn_getCategoryHeader(this.filterModel.Category);
      this.nextPanel(this.propName(this.listPanels, this.listPanels.product));
    }
  }

  fn_searchProducts() {
    this.isDisplay = 'none';
    this.fn_ResetProductList();
    this.searchString = this.searchForm.controls['searchProduct'].value;
    this.filterModel.Skip = 0;
    this.filterModel.searchBy = this.searchString ? this.searchString : '';
    this.filterModel.Category = '';
    this.nextPanel(this.propName(this.listPanels, this.listPanels.product));
    this.categoryHeader = '';
    // Set persistent message before fetch so text shows from the first frame of the
    // loader — only when previews will be generated.
    if (this.designData && (this.designData.designUrl || this.designData.previewUrl)) {
      this.loader.setPersistentMessage('Generating product preview');
    }
    this.fn_GetProducts();
  }

  fn_FetchProducts(id: string) {
    let cat = this.filterList.Categories.find(x => x.ID.toString() == id);
    if (cat && cat.SubCategories && cat.SubCategories.length > 0) {
      this.categoryHeader = "Browse by Sub-Categories";
      this.Categories = cat.SubCategories.map(s => {
        return {
          ...s,
          CoverImage: this.resolveProductImageUrl(s.CoverImage)
        }
      });
    }
    else {
      this.nextPanel(this.propName(this.listPanels, this.listPanels.product));
      this.categoryHeader = this.fn_getCategoryHeader(id);
      this.filterModel.Category = id;
      this.filterModel.Skip = 0; // reset Skip so a fresh category always starts at page 1
      this.fn_ResetProductList();
      // Set the persistent message before the fetch so the text is visible from the
      // first frame of the loader — but only when previews will actually be generated.
      if (this.designData && (this.designData.designUrl || this.designData.previewUrl)) {
        this.loader.setPersistentMessage('Generating product preview');
      }
      this.fn_GetProducts();
      this.filterComp.fn_ShowReset(true);
    }
  }

  nextPanel(showPanel: string) {
    // tslint:disable-next-line:forin
    for (const panel in this.listPanels) {
      if (this.listPanels.hasOwnProperty(panel)) {
        this.listPanels[panel] = false;
      }
    }
    this.listPanels[showPanel] = true;
  }
  propName(prop, value) {
    for (var i in prop) {
      if (prop[i] == value) {
        return i;
      }
    }
    return '';
  }

  fn_getCategoryHeader(id: string): string {
    let selectedCat: CategoryFilterModel = null;
    this.filterList.Categories.every((c) => {
      if (c.ID.toString() == id) {
        selectedCat = {
          SubCategories: [],
          ID: c.ID,
          Name: c.Name,
          CoverImage: ''
        };
        return false;
      }
      else if (c.SubCategories.some(x => x.ID.toString() == id)) {
        selectedCat = {
          SubCategories: c.SubCategories.filter(x => x.ID.toString() == id),
          ID: c.ID,
          Name: c.Name,
          CoverImage: ''
        };
        return false;
      }
      return true;
    });
    if (selectedCat) {
      let headerText = selectedCat.Name;
      if (selectedCat.SubCategories.length > 0)
        headerText = headerText + " > " + selectedCat.SubCategories[0].Name;
      return headerText;
    }
    else
      return null;
  }

  fn_OpenUploadDialog() {
    const dialogRef = this.dialog.open(UploadFileComponent, {
      width: '600px'
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });
  }

  // fn_OpenUploadShipCostDialog() {
  //   const dialogRef = this.dialog.open(UploadShipcostFileComponent, {
  //     width: '600px'
  //   });
  //
  //   dialogRef.afterClosed().subscribe((result: any) => {
  //     if (result) {
  //     }
  //   });
  // }
  // All 42 ImpressDecorationLocationCodes, each tagged with a ParentSide (Front/Back/Left/
  // Right) — same data the Print Locations tab uses. Loaded once; getRegionChips() below
  // just filters this in memory per card.
  private loadDecorationLocationCodes(): void {
    this.decorationLocationCodeService.getAll().subscribe({
      next: (codes: any[]) => {
        this.decorationLocationCodes = (codes || []).filter(c => c.isActive && !c.isDeleted);
      },
      error: (error) => {
        console.error('Error loading decoration location codes:', error);
      }
    });
  }

  // Only the regions this product actually has a print template configured for — the same
  // `!!side.TemplateId` signal customizeProduct() above already uses to find "the active
  // side" for editing. NOT based on whether a photo exists: garment photography commonly
  // covers all 4 physical angles even when only 1-2 sides have actually been set up as
  // print locations for this specific product, so photo-presence alone over-shows sides.
  getActiveCardRegions(product: ProductList): string[] {
    const active = new Set<string>();
    for (const side of (product.Sides || [])) {
      if (!side.TemplateId) continue;
      const n = (side.Name || side.DisplayName || '').toLowerCase().replace(/[\s_-]+/g, '');
      active.add(this.regionForSideName(n));
    }
    return this.cardRegions.filter(r => active.has(r));
  }

  // Thumbnail row, filtered to the same active-region set as the tabs above (so a side with
  // a photo but no configured template doesn't show a thumbnail with nothing behind it).
  getActiveCardThumbnails(product: ProductList): string[] {
    const currentStyle = product.Styles?.find((s: any) => s.ID === product.StyleId);
    if (!currentStyle) return [];
    const activeRegions = new Set(this.getActiveCardRegions(product));
    return this.getProductImageList(product).filter(img =>
      activeRegions.has(this.regionForSideName(this.getSideNameFromStyle(currentStyle, img).replace(/[\s_]+/g, '')))
    );
  }

  // Active region tab: explicit state (cardActiveRegion) once anything's been clicked, so the
  // tab underline and location-chip row switch INSTANTLY on click instead of waiting on the
  // async preview to finish (see the cardActiveRegion field comment above for why that mattered).
  // Before any click, falls back to deriving from the product's currently displayed side/thumbnail
  // — same derivation isThumbnailActive() uses — so initial render still picks the right tab.
  getCardRegion(product: ProductList): string {
    const explicit = this.cardActiveRegion[product.ProductId];
    if (explicit) return explicit;
    const currentStyle = product.Styles?.find((s: any) => s.ID === product.StyleId);
    const currentImage = this.getProductCurrentImage(product);
    if (!currentStyle || !currentImage) return 'Front';
    const sideName = this.getSideNameFromStyle(currentStyle, currentImage).replace(/[\s_]+/g, '');
    return this.regionForSideName(sideName);
  }

  // Which side thumbnail currently drives the big preview image — clicking a side thumbnail
  // (selectProductImage) is the only way this changes now that each side shows its own
  // independent placement dropdown instead of a shared tab row.
  private setCardActiveRegion(product: ProductList, region: string): void {
    this.cardActiveRegion[product.ProductId] = region;
  }

  // The thumbnail image URL for a given region/side, so each side-thumbnail column can render
  // its own image and hand it to selectProductImage() on click (same click-to-preview path the
  // old shared thumbnail row already used).
  getThumbnailForRegion(product: ProductList, region: string): string | null {
    const currentStyle = product.Styles?.find((s: any) => s.ID === product.StyleId);
    if (!currentStyle) return null;
    return this.getProductImageList(product).find(img =>
      this.regionForSideName(this.getSideNameFromStyle(currentStyle, img).replace(/[\s_]+/g, '')) === region
    ) || null;
  }

  // "front"/"back"/"leftsleeve"/"rightsleeve" (whatever getSideNameFromStyle returns, minus
  // spaces/underscores) → one of the 4 region-tab labels.
  private regionForSideName(sideName: string): string {
    if (sideName.includes('back')) return 'Back';
    if (sideName.includes('left')) return 'Left';
    if (sideName.includes('right')) return 'Right';
    return 'Front';
  }

  // The matching product.Sides[] entry for a region tab — same substring-matching
  // convention as imageFieldForSide() above (side Name/DisplayName has no separator,
  // e.g. "sleeveright" / "Right Sleeve").
  private findSideForRegion(product: ProductList, region: string): any {
    const target = region.toLowerCase();
    return (product.Sides || []).find((s: any) => {
      const n = (s.Name || s.DisplayName || '').toLowerCase().replace(/[\s_-]+/g, '');
      if (target === 'back') return n.includes('back');
      if (target === 'left') return n.includes('left');
      if (target === 'right') return n.includes('right');
      return n.includes('front') || (!n.includes('back') && !n.includes('left') && !n.includes('right'));
    });
  }

  // Every print location actually configured on this product's side (Print Locations tab
  // can attach several to one side, e.g. Front → "Full Front" + "Above Pocket") — not every
  // code tagged for that region. Comes straight off side.TemplatePlacements, which the backend
  // returns per side (all non-deleted placements, default first).
  // A placement with no TemplateId ("No template yet" in the Print Locations tab) can't actually
  // render anything — showing it as a pickable chip here would let the card land on a location
  // with nothing to preview, so it's excluded until a template is assigned to it.
  //
  // LEGACY-DATA FALLBACK (remove once migrated — see docs/post-migration-todo-sidetemplateplacement.md):
  // a side's ORIGINAL default location can still live only on the legacy Sides.TemplateId/
  // DecorationLocationCodeId columns (dual-write mirror, pre-dating SideTemplatePlacements), with
  // no SideTemplatePlacements row of its own yet. If a second, genuinely-new location is then added
  // via the Print Locations tab, side.TemplatePlacements gets an entry for that new one but still
  // nothing for the original default — so without this fallback, adding a location would make the
  // pre-existing one silently vanish from this card instead of the two coexisting. Detected via "no
  // TemplatePlacements entry is IsDefault"; once every side's default is backfilled into a real
  // SideTemplatePlacements row, that will always be true here and this whole fallback is a no-op.
  getRegionChips(product: ProductList, region: string): any[] {
    const side = this.findSideForRegion(product, region);
    if (!side) return [];
    const placements = (side.TemplatePlacements || []).filter((p: any) => p.DecorationLocationCode && p.TemplateId);
    const chips = placements.map((p: any) => ({
      impressDecorationLocationCodeId: p.DecorationLocationCodeId,
      description: p.DecorationLocationCode,
      isDefault: !!p.IsDefault
    }));

    const legacyName = (side.InkSoftLocationName || '').trim().toLowerCase();
    const alreadyCovered = !legacyName || chips.some(c =>
      c.isDefault || (c.description || '').trim().toLowerCase() === legacyName
    );
    if (!alreadyCovered) {
      const match = this.decorationLocationCodes.find(c =>
        c.parentSide === region && (c.description || '').trim().toLowerCase() === legacyName
      );
      // No matching decoration-location code found (very old data) still gets shown with its raw
      // saved name rather than silently dropped — impressDecorationLocationCodeId stays null, so
      // selecting it is a harmless no-op (nothing in TemplatePlacements has a null id to match).
      chips.unshift(match ? { ...match, isDefault: true } : {
        impressDecorationLocationCodeId: null,
        description: side.InkSoftLocationName,
        isDefault: true
      });
    }

    return chips;
  }

  // `${productId}_${region}` — the key every side's independent placement pick is stored under.
  private sideLocationKey(product: ProductList, region: string): string {
    return `${product.ProductId}_${region}`;
  }

  // Defaults to whichever chip is the side's default location when nothing's been explicitly
  // picked yet for THIS side — matches the mockup showing the starred/default location
  // pre-selected in each side's own dropdown.
  isSideLocationSelected(product: ProductList, region: string, chip: any): boolean {
    const explicit = this.cardSubLocation[this.sideLocationKey(product, region)];
    if (explicit != null) return explicit === chip.impressDecorationLocationCodeId;
    return !!chip.isDefault;
  }

  selectSideLocation(product: ProductList, region: string, locationIdRaw: string | number, event?: Event): void {
    event?.stopPropagation();
    const locationId = Number(locationIdRaw);
    this.cardSubLocation[this.sideLocationKey(product, region)] = locationId;
    // Picking a location for a side also makes that side the active one — big preview image and
    // highlighted thumbnail switch to it — rather than silently updating a dropdown for a side
    // that isn't even the one currently shown.
    this.setCardActiveRegion(product, region);
    const chip = this.getRegionChips(product, region).find(c => c.impressDecorationLocationCodeId === locationId);
    if (chip) this.refreshPreviewForLocation(product, chip);
  }

  // The chip currently shown as selected for this side — same "explicit pick, else side's
  // default" rule as isSideLocationSelected() — used as the closed dropdown's label text.
  getSelectedRegionChip(product: ProductList, region: string): any {
    const chips = this.getRegionChips(product, region);
    return chips.find(c => this.isSideLocationSelected(product, region, c)) || chips[0] || null;
  }

  toggleLocationDropdown(product: ProductList, region: string, event?: Event): void {
    event?.stopPropagation();
    const key = this.sideLocationKey(product, region);
    this.openLocationDropdownKey = this.openLocationDropdownKey === key ? null : key;
  }

  isLocationDropdownOpen(product: ProductList, region: string): boolean {
    return this.openLocationDropdownKey === this.sideLocationKey(product, region);
  }

  closeLocationDropdown(): void {
    this.openLocationDropdownKey = null;
  }

  // Any click that reaches document (i.e. wasn't already stopped by the dropdown's own toggle/
  // option handlers) is by definition outside the open dropdown — close it.
  @HostListener('document:click')
  onDocumentClick(): void {
    if (this.openLocationDropdownKey) {
      this.openLocationDropdownKey = null;
    }
  }

  // The description of every active side's currently-selected location, in region order — used
  // by the colorway tray summary line (e.g. "center chest · center back · left sleeve").
  getAllSelectedSideLocationNames(product: ProductList): string[] {
    const names: string[] = [];
    for (const region of this.getActiveCardRegions(product)) {
      const chips = this.getRegionChips(product, region);
      const selected = chips.find(c => this.isSideLocationSelected(product, region, c)) || chips[0];
      if (selected) names.push(selected.description);
    }
    return names;
  }

  // Cache key for a generated preview. The default location keeps the plain `${productId}_${sideName}`
  // key every other cache lookup in this file already expects (isThumbnailActive/customizeProduct/
  // generatePreviewForProduct) — only a non-default location gets a location-qualified key, so
  // switching TO the default never breaks those existing lookups, and switching between several
  // non-default locations on the same side each cache independently instead of clobbering one slot.
  private buildPreviewCacheKey(productId: any, sideName: string, locationId?: number | null): string {
    return locationId != null ? `${productId}_${sideName}_loc${locationId}` : `${productId}_${sideName}`;
  }

  // Resolves `side` against whichever print-location the user explicitly picked for THIS side
  // (cardSubLocation, keyed per-side via sideLocationKey — set by selectSideLocation), swapping in
  // that placement's own TemplateId/PrintPlacement in place of the side's default/mirrored ones.
  // Falls back to `side` unchanged when nothing's been explicitly picked, or that placement has no
  // template/zone of its own (every SideTemplatePlacement carries both, so this is a defensive
  // guard against unexpected data, not the normal path). Single source of truth for "which
  // location is actually in effect for this side right now" — used both to preview a location
  // change live and to carry that same choice into the DesignHuddle project actually created for
  // "Continue with N Products", so what you see on the card is what gets built.
  private applySelectedLocation(product: ProductList, side: any, locationId?: number): any {
    const region = this.regionForSideName((side.Name || side.DisplayName || '').toLowerCase().replace(/[\s_-]+/g, ''));
    const explicitLocationId = locationId ?? this.cardSubLocation[this.sideLocationKey(product, region)];
    if (explicitLocationId == null) return side;
    const placement = (side.TemplatePlacements || []).find((p: any) =>
      p.DecorationLocationCodeId === explicitLocationId
    );
    if (!placement || !placement.TemplateId) return side;
    return {
      ...side,
      TemplateId: placement.TemplateId,
      PrintPlacement: placement.PrintPlacement || side.PrintPlacement
    };
  }

  // Switching the print-location chip within a side must behave like switching sides: use that
  // specific location's own TemplateId/PrintPlacement (not the side's default/mirrored one, which
  // is all `side.TemplateId`/`side.PrintPlacement` ever reflect) and regenerate the DesignHuddle
  // preview against that zone — same generateSidePreview() pipeline selectProductImage() already
  // drives for a side change, just fed the specific placement's template/zone instead of the side's.
  private refreshPreviewForLocation(product: ProductList, chip: any): void {
    if (!this.designData || (!this.designData.designUrl && !this.designData.previewUrl)) return;
    const designUrl = this.designData.designUrl || this.designData.previewUrl;

    const region = this.getCardRegion(product);
    const side = this.findSideForRegion(product, region);
    if (!side) return;

    const currentStyle: any = (product as any).Styles?.find((s: any) => s.ID === product.StyleId);
    if (!currentStyle) return;

    const effectiveSide = this.applySelectedLocation(product, side, chip.impressDecorationLocationCodeId);
    if (!effectiveSide.TemplateId) return;

    let sideImageUrl = currentStyle[side.ImageField || this.imageFieldForSide(side)] || '';
    if (sideImageUrl && !sideImageUrl.startsWith('http')) {
      sideImageUrl = this.masterProductImgBaseURL + sideImageUrl;
    }
    if (!sideImageUrl) sideImageUrl = (product as any).ImageUrl;

    const sideName = this.getSideNameFromStyle(currentStyle, sideImageUrl);
    const locationId = chip.isDefault ? null : chip.impressDecorationLocationCodeId;
    const cacheKey = this.buildPreviewCacheKey(product.ProductId, sideName, locationId);

    if (this.generatedPreviews.has(cacheKey)) {
      this.productCurrentImages.set(product.ProductId, this.generatedPreviews.get(cacheKey)!);
      return;
    }

    this.loadingPreviews.add(product.ProductId);
    this.generateSidePreview(product, effectiveSide, sideImageUrl, designUrl, sideName, locationId);
  }

  // Multi-select colorway staging (designData mode only) — clicking a swatch toggles it in
  // the staged set instead of single-selecting it. The most-recently-staged colorway still
  // drives selectStyleToCustomize() so the existing single-StyleId preview/build pipeline
  // (customizeProduct/toggleProductSelection/proceedToColorSelection) keeps working unchanged.
  // The product's current/default color starts pre-checked ("1 of N selected") — the default
  // color is always the one already selected, matching the swatch's own checkmark convention
  // from before multi-select staging existed.
  private stagedColorways: { [productId: string]: Set<string> } = {};
  // The ORIGINAL default StyleId a product's staged set was seeded with — captured once, so it
  // survives later clicks changing product.StyleId to whichever color was staged/previewed most
  // recently. Carried through to product-color-selection as the color that stays locked/uncheckable
  // there, regardless of which color the DesignHuddle preview was last generated against.
  private defaultStagedStyleId: { [productId: string]: any } = {};

  private getStagedColorwaySet(product: ProductList): Set<string> {
    let staged = this.stagedColorways[product.ProductId];
    if (!staged) {
      staged = new Set<string>();
      if (product.StyleId != null) {
        staged.add(product.StyleId as any);
        this.defaultStagedStyleId[product.ProductId] = product.StyleId;
      }
      this.stagedColorways[product.ProductId] = staged;
      this.persistBuildState();
    }
    return staged;
  }

  // Persists staged-colorway state into StateService (a singleton, so this survives navigating
  // to color-selection and back — unlike this component's own fields, which reset on re-init)
  // and restores it back out. Without this, going "Continue" → color-selection → Back reset
  // every product's staging to a single default color again.
  private persistBuildState(): void {
    this.stateService.setStagedColorwayState({
      stagedColorways: this.stagedColorways,
      defaultStagedStyleId: this.defaultStagedStyleId
    });
  }

  private restoreBuildState(): void {
    const staged = this.stateService.getStagedColorwayState();
    if (staged) {
      this.stagedColorways = staged.stagedColorways || {};
      this.defaultStagedStyleId = staged.defaultStagedStyleId || {};
    }
  }

  // Snapshot of a product carrying its staged colorway state, taken at the moment it's added to
  // the build (selectedProductsDataMap) — plain object spreads elsewhere in this file don't know
  // about stagedColorways, so this is the one place that bridges "what's checked on the card"
  // into "what continueWithSelectedProducts()/proceedToColorSelection() carry forward".
  private snapshotForBuild(product: ProductList): any {
    return {
      ...product,
      StagedStyleIds: Array.from(this.getStagedColorwaySet(product)),
      DefaultStagedStyleId: this.defaultStagedStyleId[product.ProductId] ?? product.StyleId
    };
  }

  isColorwayStaged(product: ProductList, style: any): boolean {
    return this.getStagedColorwaySet(product).has(style.ID);
  }

  toggleColorwayStaged(product: ProductList, style: any, productIndex: number, event: Event): void {
    event.stopPropagation();
    const staged = this.getStagedColorwaySet(product);
    if (staged.has(style.ID)) {
      staged.delete(style.ID);
      // Unstaging the color that's currently the locked/default one (defaultStagedStyleId,
      // carried to product-color-selection as selectedStyleId/lockedStyleId — see
      // snapshotForBuild/proceedToColorSelection) must not leave it pointing at a color the user
      // just unchecked here: product-color-selection resolves that id against the product's FULL
      // Styles list, not against what's actually staged, so the removed color would otherwise
      // still show up there as the locked default. Promote the EARLIEST still-staged color
      // instead (the Set's insertion order — the first one the user checked), not swatch display
      // order and not the most-recently-checked one.
      if (this.defaultStagedStyleId[product.ProductId] === style.ID) {
        const remainingStagedIds = Array.from(staged);
        const nextDefaultId = remainingStagedIds.length > 0 ? remainingStagedIds[0] : null;
        if (nextDefaultId != null) {
          const nextDefaultStyle = product.Styles.find((s: any) => s.ID === nextDefaultId);
          if (nextDefaultStyle) {
            this.selectStyleToCustomize(nextDefaultStyle, productIndex);
          }
          this.defaultStagedStyleId[product.ProductId] = nextDefaultId;
        } else {
          // No colors staged anymore — nothing valid to promote.
          delete this.defaultStagedStyleId[product.ProductId];
        }
      }
    } else {
      staged.add(style.ID);
      this.selectStyleToCustomize(style, productIndex);
    }
    this.persistBuildState();
  }

  getStagedColorwayCount(product: ProductList): number {
    return this.getStagedColorwaySet(product).size;
  }

  // Swatch row is truncated to one line, "+N more" revealing the rest on click — matches the
  // mockup instead of the legacy nowrap/ellipsis + separate total-count badge. swatchesPerRow is
  // a fixed estimate (not measured per-card) of how many 28px swatches fit before wrapping at
  // this grid's card width; tune this constant if the real row wraps earlier/later than it should.
  private readonly swatchesPerRow = 10;
  private expandedColorwaySwatches = new Set<string>();

  private getActiveStyles(product: ProductList): any[] {
    return (product.Styles || []).filter((s: any) => s.IsActive);
  }

  isColorwaySwatchRowExpanded(product: ProductList): boolean {
    return this.expandedColorwaySwatches.has(String(product.ProductId));
  }

  // Staged colors always show in the visible row, even if their position in product.Styles would
  // otherwise put them past swatchesPerRow — a color you've already picked shouldn't silently
  // disappear behind "+N more" just because it happens to be later in the list. Row order is
  // otherwise preserved (this only ever ADDS staged swatches back in, never reorders).
  getVisibleColorwaySwatches(product: ProductList): any[] {
    const active = this.getActiveStyles(product);
    if (this.isColorwaySwatchRowExpanded(product)) return active;
    const firstN = active.slice(0, this.swatchesPerRow);
    const stagedButHidden = active.slice(this.swatchesPerRow).filter((s: any) => this.isColorwayStaged(product, s));
    if (stagedButHidden.length === 0) return firstN;
    const visibleIds = new Set([...firstN, ...stagedButHidden].map((s: any) => s.ID));
    return active.filter((s: any) => visibleIds.has(s.ID));
  }

  getHiddenColorwaySwatchCount(product: ProductList): number {
    if (this.isColorwaySwatchRowExpanded(product)) return 0;
    return this.getActiveStyles(product).length - this.getVisibleColorwaySwatches(product).length;
  }

  toggleColorwaySwatchRowExpanded(product: ProductList, event: Event): void {
    event.stopPropagation();
    const key = String(product.ProductId);
    if (this.expandedColorwaySwatches.has(key)) {
      this.expandedColorwaySwatches.delete(key);
    } else {
      this.expandedColorwaySwatches.add(key);
    }
  }

  // Add-to-build button label. Before the product is added to the build: always the generic
  // "Select colorways to add" call-to-action, regardless of how many colorways are staged —
  // staging picks which colors will be included, this button is the separate "commit" step.
  // Once added: switches to the count-based "Add N colorway(s) to build" as a running summary of
  // what's included, instead of freezing on a static "Selected" that never reflected changes if
  // more colorways were staged afterward.
  getAddToBuildLabel(product: ProductList): string {
    if (!this.isProductSelected(product.ProductId)) return 'Select colorways to add';
    const count = this.getStagedColorwayCount(product);
    return `Add ${count} colorway${count === 1 ? '' : 's'} to build`;
  }

  selectStyleToCustomize(style: any, productIndex: any) {
    // const selectedStyle = style.Sizes.sort((a, b) => a.SortOrder - b.SortOrder);
    this.productList[productIndex].StyleId = style.ID;
    this.productList[productIndex].ImageUrl = this.resolveProductImageUrl(style.ImageFilePath_Front);

    // Update image list for the selected style
    const productId = this.productList[productIndex].ProductId;
    const imageList = [];

    if (style.ImageFilePath_Front) {
      imageList.push(this.resolveProductImageUrl(style.ImageFilePath_Front));
    }
    if (style.ImageFilePath_Back) {
      imageList.push(this.resolveProductImageUrl(style.ImageFilePath_Back));
    }
    if (style.ImageFilePath_SleeveLeft) {
      imageList.push(this.resolveProductImageUrl(style.ImageFilePath_SleeveLeft));
    }
    if (style.ImageFilePath_SleeveRight) {
      imageList.push(this.resolveProductImageUrl(style.ImageFilePath_SleeveRight));
    }

    // Update maps with new images for the selected color/style
    this.productImageLists.set(productId, imageList);
    if (imageList.length > 0) {
      // Keep whichever side the user is currently viewing (productSideNames, set by every
      // generateSidePreview call) instead of always jumping back to Front — previously this
      // always picked imageList[0] (Front is pushed first above whenever present), so choosing
      // a colorway while viewing Back/a sleeve silently flipped the preview back to Front.
      // Falls back to imageList[0] when the new style has no image for that side (e.g. a
      // colorway missing a sleeve photo).
      const trackedSideName = this.productSideNames.get(String(productId));
      const preferredField = trackedSideName ? this.imageFieldForSide({ Name: trackedSideName }) : 'ImageFilePath_Front';
      const preferredPath = style[preferredField];
      const preferredImageUrl = preferredPath ? this.resolveProductImageUrl(preferredPath) : null;
      this.productCurrentImages.set(productId, preferredImageUrl || imageList[0]);
    }

    // If design data exists, regenerate preview for the new color/style
    if (this.designData && (this.designData.designUrl || this.designData.previewUrl)) {
      const designUrl = this.designData.designUrl || this.designData.previewUrl;
      const product = this.productList[productIndex];

      console.log('🎨 Color changed, regenerating preview for product:', productId);

      // Clear cached previews for this product (all sides)
      const cacheKeysToDelete = Array.from(this.generatedPreviews.keys()).filter(key =>
        key.startsWith(`${productId}_`)
      );
      cacheKeysToDelete.forEach(key => this.generatedPreviews.delete(key));
      console.log('🗑️ Cleared cached previews:', cacheKeysToDelete);

      // Regenerate preview for the front side of the new color
      this.generatePreviewForProduct(product, designUrl);
    }

    //this.productList[productIndex].UnitCost = selectedStyle[0].UnitPrice;
    // this.productList[productIndex].Sizes = Array.prototype.map.call(selectedStyle, function (item) {
    //   return item.Name;
    // }).join('  ');
  }

  fn_OpenDesignList(product: any) {
    const dialogRef = this.dialog.open(DesignListComponent, {
      width: '90vw',
      height: '90vh',
      data: {
        customizationType: product.CustomizationType, productId: product.ProductId,
        categoryId: product.CategoryId, styleId: product.StyleId, sizes: product.Sizes,
        productAdditionalInfo: product.ProductAdditionalInfo
      }
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result != null) {
        this.fn_GotoDesignStudio(result);
      }
    });
  }
  fn_GotoDesignStudio(data) {
    this.ProductData.emit(data);
  }

  viewProductDetail(productId: number): void {
    this.router.navigate(['/superadmin/masterproduct/detail', productId]);
  }

  getLabelArray(labelString: string): string[] {
    const labelsArray = labelString.split(',').slice(0, 5);
    if (labelsArray && labelsArray.length > 0)
      return labelsArray;
    else return []
  }

  // Resolve a stored image path. Post-migration values are already absolute Azure URLs;
  // legacy InkSoft values are relative paths needing the masterProductImgBaseURL prefix.
  // Prepending unconditionally produces broken `https://stores.inksoft.comhttps://...` URLs.
  private resolveProductImageUrl(path: string): string {
    if (!path) return '';
    if (path.startsWith('http://') || path.startsWith('https://')) return path;
    return this.masterProductImgBaseURL + path;
  }

  // Get image list for a product
  getProductImageList(product: ProductList): string[] {
    return this.productImageLists.get(product.ProductId) || [];
  }

  // Get current main image for a product
  getProductCurrentImage(product: ProductList): string {
    return this.productCurrentImages.get(product.ProductId) || product.ImageUrl;
  }

  // Check if thumbnail is active
  isThumbnailActive(product: ProductList, thumbnailUrl: string): boolean {
    const currentStyle = product.Styles.find((s: any) => s.ID === product.StyleId);
    if (!currentStyle) return false;

    const thumbnailSide = this.getSideNameFromStyle(currentStyle, thumbnailUrl);
    const currentImage = this.getProductCurrentImage(product);
    const cacheKey = `${product.ProductId}_${thumbnailSide}`;
    const cachedUrl = this.generatedPreviews.get(cacheKey);

    return currentImage === cachedUrl || currentImage === thumbnailUrl;
  }

  // Handle thumbnail click to change main image (similar to selectProductStyle in detail component)
  selectProductImage(product: ProductList, imageUrl: string): void {
    // If design data exists, check cache first before changing image
    if (this.designData && (this.designData.designUrl || this.designData.previewUrl) && product.Sides) {
      const designUrl = this.designData.designUrl || this.designData.previewUrl;

      // Get current style to determine side from ImageFilePath_ fields
      const currentStyle = product.Styles.find((s: any) => s.ID === product.StyleId);
      if (!currentStyle) {
        console.warn('⚠️ Current style not found');
        this.productCurrentImages.set(product.ProductId, imageUrl);
        return;
      }

      // Get side name from style's ImageFilePath fields
      const sideName = this.getSideNameFromStyle(currentStyle, imageUrl);
      const currentSide = product.Sides.find((s: any) =>
        s.Name?.toLowerCase() === sideName.toLowerCase() ||
        s.DisplayName?.toLowerCase() === sideName.toLowerCase()
      );

      // Track which side thumbnail is now active, so the big preview image and the
      // active-thumbnail highlight stay in sync with whichever thumbnail was actually clicked.
      this.setCardActiveRegion(product, this.regionForSideName(sideName.replace(/[\s_]+/g, '')));

      if (currentSide && currentSide.TemplateId) {
        const cacheKey = `${product.ProductId}_${sideName}`;

        // Store original image URL for this side if not stored yet
        if (!this.originalImageUrls.has(cacheKey)) {
          this.originalImageUrls.set(cacheKey, imageUrl);
          console.log('📝 Stored original URL for:', cacheKey);
        }

        // Check if preview already generated for this side
        if (this.generatedPreviews.has(cacheKey)) {
          console.log('✅ Using cached preview for side:', sideName, 'cache key:', cacheKey);
          const cachedUrl = this.generatedPreviews.get(cacheKey);

          // Update current image
          this.productCurrentImages.set(product.ProductId, cachedUrl!);
        } else {
          // Show loading and generate preview
          console.log('🔄 Generating DesignHuddle preview for side:', currentSide.Name, 'cache key:', cacheKey);
          this.loadingPreviews.add(product.ProductId);
          this.generateSidePreview(product, currentSide, imageUrl, designUrl, sideName);
        }
      } else {
        // No design preview, just change image normally
        this.productCurrentImages.set(product.ProductId, imageUrl);
      }
    } else {
      // No design data, just change image normally
      this.productCurrentImages.set(product.ProductId, imageUrl);
    }
  }

  // Check if product is loading preview
  isProductLoading(productId: string): boolean {
    return this.loadingPreviews.has(productId);
  }

  fn_ShowUploadButtons() {
    if ((this.userRole == 'SuperAdmin' || this.userRole == 'CustomerService') && !this.router.url.includes('superadmin/shopify-products-add-product'))
      return true;
  }
  fn_IsAddProductUrl() {
    if (this.router.url.includes('superadmin/shopify-products-add-product'))
      return true;
  }

  // Product selection methods
  isProductSelected(productId: string | number): boolean {
    return this.selectedProducts.has(String(productId));
  }

  toggleProductSelection(product: ProductList): void {
    const productId = String(product.ProductId);
    if (this.selectedProducts.has(productId)) {
      this.selectedProducts.delete(productId);
      this.selectedProductsDataMap.delete(productId);
    } else {
      this.selectedProducts.add(productId);
      this.selectedProductsDataMap.set(productId, this.snapshotForBuild(product));
    }
    this.selectedProductsCount = this.selectedProducts.size;

    // Save to state service
    this.stateService.setSelectedProductsForDesign(Array.from(this.selectedProducts));
    console.log('✅ Product selection updated. Total selected:', this.selectedProductsCount);
  }

  customizeProduct(product: ProductList): void {
    console.log('🎨 Customize product:', product.ProductId);

    // Get current style
    const currentStyle = (product as any).Styles?.find((s: any) => s.ID === (product as any).StyleId);
    if (!currentStyle) {
      console.warn('⚠️ Current style not found for product:', product.ProductId);
      return;
    }

    // Find the active side + print-location the same way the card preview does — NOT by
    // matching the currently displayed image against the plain (default-location) cache key,
    // which only ever matches the DEFAULT location's cached preview. When a non-default location
    // chip was picked, that preview caches under a location-qualified key (buildPreviewCacheKey),
    // so the old match here always missed and silently fell back to "first side with TemplateId"
    // — opening the editor on the side's default location (e.g. Full Front) even though the card
    // was showing a different one (e.g. Above Pocket).
    const region = this.getCardRegion(product);
    let currentSide: any = this.findSideForRegion(product, region);
    if (currentSide) {
      currentSide = this.applySelectedLocation(product, currentSide);
    }

    // Fallback: first side with TemplateId
    if (!currentSide || !currentSide.TemplateId) {
      currentSide = (product as any).Sides?.find((s: any) => s.TemplateId);
    }

    if (!currentSide || !currentSide.TemplateId) {
      console.warn('⚠️ No side with template found');
      return;
    }

    // If project title was already saved, skip dialog and go directly to editor
    const editorEntry = this.getEditorSideDataForProduct(String(product.ProductId));
    if (editorEntry && editorEntry.projectTitle) {
      this.openEditorWithTitle(product, currentStyle, currentSide, editorEntry.projectTitle);
      return;
    }

    // Show project title dialog before opening editor
    const dialogData = {
      title: 'Enter Project Title',
      message: 'Please provide a title for this project:',
      storeId: this.storeId,
      isEditMode: this.stateService.isEditMode(),
      products: [{
        productId: product.ProductId,
        productName: (product as any).Description,
        projectTitle: `${(product as any).Description}_Design`,
        disabled: false
      }]
    };

    const dialogRef = this.dialog.open(ProjectTitlesDialogComponent, {
      width: '600px',
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirmed) {
        const projectTitle = result.projectTitles[0] || `${(product as any).Description}_Design`;
        this.openEditorWithTitle(product, currentStyle, currentSide, projectTitle);
      }
    });
  }

  private openEditorWithTitle(product: ProductList, currentStyle: any, currentSide: any, projectTitle: string): void {
    const templateId = parseInt(currentSide.TemplateId);

    // Get product image URL using side's ImageField
    let sideImageUrl = currentStyle[currentSide.ImageField || this.imageFieldForSide(currentSide)] || '';
    if (sideImageUrl && !sideImageUrl.startsWith('http')) {
      sideImageUrl = this.masterProductImgBaseURL + sideImageUrl;
    }
    if (!sideImageUrl) {
      sideImageUrl = (product as any).ImageUrl;
    }

    console.log('🖼️ Editor product_image_url:', sideImageUrl, 'ImageField:', currentSide.ImageField);

    // Parse PrintPlacement for zone dimensions and offset
    let zoneDimensions = '300x300';
    let zoneOffset = '100x100';
    if (currentSide.PrintPlacement) {
      try {
        const pp = typeof currentSide.PrintPlacement === 'string'
          ? JSON.parse(currentSide.PrintPlacement)
          : currentSide.PrintPlacement;
        if (pp.Width && pp.Height) {
          zoneDimensions = `${pp.Width}x${pp.Height}`;
        }
        if (pp.X !== undefined && pp.Y !== undefined) {
          zoneOffset = `${pp.X}x${pp.Y}`;
        }
      } catch (e) {
        console.warn('Failed to parse PrintPlacement:', e);
      }
    }

    // Get design URL
    const designUrl = this.designData?.designUrl || this.designData?.previewUrl;
    if (!designUrl) {
      console.warn('⚠️ No design URL available');
      return;
    }

    // Track which product/side is being edited
    const sideName = (currentSide.Name || currentSide.DisplayName || 'front').toLowerCase();
    this.currentEditorProductId = String(product.ProductId);
    this.currentEditorSideName = sideName;
    this.currentEditorProjectTitle = projectTitle;

    // Open modal and show loading state
    this.editorProductName = (product as any).Description || 'Product';
    this.showDesignHuddleEditorModal = true;
    this.isCreatingProject = true;

    // Create a DesignHuddle project from the template
    const DSHDLib = (window as any).DSHDLib;
    if (!DSHDLib) {
      console.error('❌ DesignHuddle SDK not loaded');
      this.isCreatingProject = false;
      this.showDesignHuddleEditorModal = false;
      return;
    }

    const insertEditorForProject = (projectId: string) => {
      // Insert the editor into the modal container. Capture the instance via the 3rd-arg callback
      // so closeDesignHuddleEditorModal can call instance.remove() and free the project ID from
      // the SDK registry (see dhEditorInstance field note).
      DSHDLib.Editors.insert('dh-editor-container', {
        project_id: projectId,
        product_image_url: sideImageUrl,
        product_image_width: 500,
        product_image_canvas_zone_dimensions: zoneDimensions,
        product_image_canvas_zone_offset: zoneOffset,
        // Top-anchor the design in the editor too (chest print), matching the preview/export.
        // Editors.insert supports this param (verified against the DH SDK); without it the SDK
        // defaults to centered, so the editor disagreed with the top-anchored preview.
        product_image_canvas_zone_vertical_align: 'top'
      }, (insertErr: any, instance: any) => {
        if (insertErr) {
          console.error('❌ [master-products] Editors.insert callback error:', insertErr);
        } else {
          this.dhEditorInstance = instance || null;
          console.log(`[master-products] editor instance received — has .remove=${typeof instance?.remove}`);
          // Override DH's own Upload-button flow so in-editor uploads run through the same
          // transparent-padding trim pipeline as the upload-design page (see service doc).
          if (this.dhEditorInstance) {
            this.uploadOverride.wireMediaUploadOverride(this.dhEditorInstance);
          }
        }
      });
      this.isCreatingProject = false;
    };

    // Reopen: reuse the SAME DH project instead of createProject-ing a fresh one from the bare
    // template. The DH project already holds whatever position the user last saved (createProject
    // here only ever seeded {url: designUrl} with no media_position, so recreating it silently
    // reset every resize/reposition back to the template's default placement on every reopen).
    const editorKey = `${this.currentEditorProductId}_${this.currentEditorSideName}`;
    const existingEntry = this.editorSideData.get(editorKey);
    if (existingEntry?.projectId) {
      this.currentEditorProjectId = existingEntry.projectId;
      console.log(`♻️ [master-products] Reusing existing DH project for ${editorKey}:`, existingEntry.projectId);
      // The createProject branch below gets a "free" delay before Editors.insert from its own
      // network round-trip, which is enough time for Angular's *ngIf to actually render the
      // '#dh-editor-container' div (showDesignHuddleEditorModal was JUST set true above — Angular
      // defers that DOM insertion to the next change-detection cycle, it isn't there yet
      // synchronously). This reuse branch has no such natural delay, so without one Editors.insert
      // runs against a container that doesn't exist yet and silently no-ops — the editor never
      // (re)opens. Match the explicit 100ms delay used elsewhere in this codebase for the same reason.
      setTimeout(() => insertEditorForProject(existingEntry.projectId), 100);
      return;
    }

    DSHDLib.createProject({
      template_id: templateId,
      project_title: toDesignHuddleProjectTitle(projectTitle),
      customizations: {
        classes: {
          logo: { url: designUrl }
        }
      }
    }, (err: any, projectData: any) => {
      if (err) {
        console.error('❌ Error creating DesignHuddle project:', err);
        this.isCreatingProject = false;
        return;
      }

      const projectId = projectData.project_id;
      this.currentEditorProjectId = projectId;
      console.log('✅ DesignHuddle project created:', projectId);

      // Store editor side data immediately so projectId is available even if metadata API fails
      this.editorSideData.set(editorKey, {
        projectId: projectId,
        projectTitle: this.currentEditorProjectTitle,
        elementPlacement: null,
        zonePlacement: null
      });
      console.log(`📌 Pre-stored editor side data for ${editorKey}`);

      insertEditorForProject(projectId);
    });
  }

  // Hides the modal and deregisters the editor instance/container from the DesignHuddle SDK —
  // the part of closing that must ALWAYS happen, whether the user saves or dismisses without
  // saving. Split out of closeDesignHuddleEditorModal() so dismissDesignHuddleEditorModal() (the
  // top-bar X — close without hitting save) can reuse it without also running the metadata-fetch/
  // save-preview steps below.
  private teardownDesignHuddleEditor(): void {
    // Step 1: Hide the modal FIRST (same order as product-color-selection/edit-master-product,
    // which reliably support reopening the SAME project N times). Angular's *ngIf DOM removal
    // runs during the NEXT change-detection cycle, so the container element is still present
    // synchronously right after this assignment — ordering this before instance.remove() below
    // is what actually matters here now that openEditorWithTitle reuses the same project_id on
    // reopen: doing remove() before hiding the modal left the SDK's registry entry for that
    // project_id in a state where a later Editors.insert() with the SAME project_id silently
    // never fired its callback (the editor just never (re)opened).
    this.showDesignHuddleEditorModal = false;

    // Step 2: Deregister the editor instance from the SDK registry. This is the ONLY call that
    // actually frees the project ID — the registry is keyed by the instance's own id, so
    // Editors.remove(containerId) is a no-op here. Without instance.remove(), reopening the same
    // project's editor (e.g. later on color-selection) throws "Only one Editor can be active per
    // Project ID".
    if (this.dhEditorInstance && typeof this.dhEditorInstance.remove === 'function') {
      try {
        this.dhEditorInstance.remove();
        console.log('[master-products] dhEditorInstance.remove() called — SDK registry entry cleared');
      } catch (removeErr) {
        console.warn('[master-products] dhEditorInstance.remove() threw (non-fatal):', removeErr);
      }
    }
    this.dhEditorInstance = null;

    // Step 3: Belt-and-suspenders — clear the container children and call the container-keyed
    // remove too (harmless if it no-ops).
    const container = document.getElementById('dh-editor-container');
    if (container) {
      container.innerHTML = '';
    }
    try {
      const DSHDLib = (window as any).DSHDLib;
      if (DSHDLib?.Editors?.remove) {
        DSHDLib.Editors.remove('dh-editor-container');
      }
    } catch (e) { }
  }

  // Top-bar X: close the editor WITHOUT saving — tears down the SDK instance (required either
  // way, see teardownDesignHuddleEditor) but skips the metadata-fetch/preview-refresh below, so
  // whatever the user changed in this session never overwrites the card's existing preview.
  dismissDesignHuddleEditorModal(): void {
    this.teardownDesignHuddleEditor();
    this.currentEditorProjectId = null;
    this.currentEditorProductId = null;
    this.currentEditorSideName = null;
    this.currentEditorProjectTitle = null;
  }

  closeDesignHuddleEditorModal(): void {
    const projectId = this.currentEditorProjectId;
    const productId = this.currentEditorProductId;
    const sideName = this.currentEditorSideName;
    const projectTitle = this.currentEditorProjectTitle;

    this.teardownDesignHuddleEditor();

    // Fetch project metadata with position info after closing editor
    if (projectId && productId && sideName) {
      this.isFetchingProjectData = true;
      this.loader.show('Saving design data...', 'Please wait while we fetch your project details.');
      this.designHuddleService.getProjectData(projectId).subscribe({
        next: (response: any) => {
          this.projectMetadata = response;

          // Parse placement data from the logo element — enrich existing entry
          const sideData = this.parseProjectMetadata(response, projectId);
          const key = `${productId}_${sideName}`;
          const existing = this.editorSideData.get(key) || {};
          if (sideData) {
            this.editorSideData.set(key, {
              ...existing,
              ...sideData,
              projectTitle: projectTitle
            });
          }

          // Detect text elements — if present, SDK preview cannot render them;
          // use export-API path instead.
          const hasTextElements = this.projectDataHasTextElements(response);
          this.currentProjectHasTextElements = hasTextElements;
          console.log(`🔤 Project ${projectId} has text elements: ${hasTextElements}`);

          if (hasTextElements) {
            // Export-based preview: POST export-job, poll for azure_url, then set as preview.
            this.refreshPreviewViaExportOnMasterProducts(projectId, productId, sideName);
            this.isFetchingProjectData = false;
            this.loader.hide();
            return;
          }

          const assetId = sideData?.assetId;

          // If we have an asset_id, fetch the actual logo via backend → Azure
          if (assetId && projectId) {
            console.log(`🔄 Fetching asset ${assetId} from project ${projectId}...`);
            this.http.get<any>(`${environment.baseUrl}/api/DesignHuddle/projects/${projectId}/assets/${assetId}`).subscribe({
              next: (assetResponse: any) => {
                const azureLogoUrl = assetResponse?.azureUrl || null;
                console.log('✅ Asset uploaded to Azure:', azureLogoUrl);

                // Pass Azure logo URL only for this product's preview, don't modify global designData.
                // Hide the loader ONLY once the preview URL is generated and the image is preloaded.
                this.refreshPreviewAfterEditor(productId, sideName, sideData, azureLogoUrl, () => {
                  this.isFetchingProjectData = false;
                  this.loader.hide();
                });
              },
              error: (err: any) => {
                console.error('❌ Failed to fetch asset:', err);
                this.refreshPreviewAfterEditor(productId, sideName, sideData, undefined, () => {
                  this.isFetchingProjectData = false;
                  this.loader.hide();
                });
              }
            });
          } else {
            // No asset_id — pass direct logo URL for this product only
            this.refreshPreviewAfterEditor(productId, sideName, sideData, sideData?.logoUrl, () => {
              this.isFetchingProjectData = false;
              this.loader.hide();
            });
          }
        },
        error: (err: any) => {
          console.error('❌ Failed to fetch project metadata:', err);
          this.isFetchingProjectData = false;
          this.loader.hide();
        }
      });
    }

    this.currentEditorProjectId = null;
    this.currentEditorProductId = null;
    this.currentEditorSideName = null;
    this.currentEditorProjectTitle = null;
  }

  /**
   * Parse project metadata to extract element and zone placement from the logo element
   */
  parseProjectMetadata(metadata: any, projectId: string): any {
    // Handle both direct response { pages: [...] } and wrapped { data: { pages: [...] } }
    const root = metadata?.pages ? metadata : (metadata?.data || metadata);
    const pages = root?.pages || [];
    console.log('📐 parseProjectMetadata - pages found:', pages.length, 'raw keys:', Object.keys(metadata || {}));
    if (pages.length === 0) return null;

    // Search through pages for an element with class "logo"
    for (const page of pages) {
      const elements = page.elements || {};
      for (const elementId of Object.keys(elements)) {
        const element = elements[elementId];
        const classes = element.element_classes || [];
        if (classes.includes('logo')) {
          const sideData: any = {
            projectId: projectId,
            elementPlacement: {
              height: element.height,
              width: element.width,
              left: element.left,
              top: element.top
            },
            zonePlacement: null,
            logoUrl: element.original_image_url || element.image_url || element.url || element.src || null,
            assetId: element.asset_id || null
          };

          if (element.zone) {
            sideData.zonePlacement = {
              height: element.zone.height,
              width: element.zone.width,
              left: element.zone.left,
              top: element.zone.top
            };
          }

          console.log('📐 Parsed placements:', sideData);
          return sideData;
        }
      }
    }

    console.warn('⚠️ No logo element found in project metadata');
    return { projectId: projectId, elementPlacement: null, zonePlacement: null };
  }

  /**
   * Calculate media_position from elementPlacement and zonePlacement.
   * scale_width = elementPlacement.width / zonePlacement.width
   * x = (elementPlacement.left + elementPlacement.width / 2 - zonePlacement.left) / zonePlacement.width
   * y = (elementPlacement.top + elementPlacement.height / 2 - zonePlacement.top) / zonePlacement.height
   */
  calculateMediaPosition(elementPlacement: any, zonePlacement: any): any {
    if (!elementPlacement || !zonePlacement) return null;
    if (!zonePlacement.width || !zonePlacement.height) return null;

    // NO REAL PLACEMENT: a freshly-created DH project reports elementPlacement === zonePlacement
    // (the design auto-fits the zone, e.g. {width:2,height:2,left:0,top:0}). That computes to a
    // CENTERED media_position {scale_width:1, x:0.5, y:0.5}, which is NOT a user placement — yet
    // being truthy it was overriding the top-anchor default in BOTH the preview and the export,
    // so every thumbnail rendered centered. Return null here so callers apply the top-anchor
    // default (computeTopAnchor / vertical_align). A genuine editor move makes element != zone.
    if (elementPlacement.left === zonePlacement.left
        && elementPlacement.top === zonePlacement.top
        && elementPlacement.width === zonePlacement.width
        && elementPlacement.height === zonePlacement.height) {
      return null;
    }

    const scale_width = elementPlacement.width / zonePlacement.width;
    const x = (elementPlacement.left + elementPlacement.width / 2 - zonePlacement.left) / zonePlacement.width;
    const y = (elementPlacement.top + elementPlacement.height / 2 - zonePlacement.top) / zonePlacement.height;

    // PRISTINE TOP-ANCHOR (not a user edit): the DH project is now SEEDED top-anchored, so an
    // unedited design comes back with its TOP edge on the zone top AND horizontally centered —
    // i.e. the exact seed. Treat only THAT structural signature as "no placement" (callers then
    // re-derive the identical top-anchor via the top-anchor default). This replaces the old ±0.02
    // near-CENTER heuristic, which also nulled GENUINE user placements that happened to land near
    // the zone center (the revert-after-edit bug). Epsilon is tight (1e-6): a design the user
    // drags vertically off the top (top edge no longer == zone top) or horizontally off-center is
    // now honored exactly as placed.
    const EPS = 1e-6;
    const centeredX = Math.abs(x - 0.5) < EPS;
    const topAligned = Math.abs(elementPlacement.top - zonePlacement.top) < EPS * (Math.abs(zonePlacement.height) || 1);
    if (centeredX && topAligned) {
      console.log('📐 media_position is the pristine top-anchor seed → null (top-anchor)');
      return null;
    }

    const mediaPosition = { scale_width, x, y };
    console.log('📐 Calculated media_position:', mediaPosition);
    return mediaPosition;
  }

  /**
   * Refresh preview image after editor close using updated media_position.
   */
  refreshPreviewAfterEditor(productId: string, sideName: string, sideData: any, overrideLogoUrl?: string, onComplete?: () => void): void {
    // Always signal completion (used by the caller to hide the loader ONLY once the preview is
    // actually ready). Guard so it fires exactly once no matter which exit path runs.
    let completed = false;
    const done = () => { if (!completed) { completed = true; onComplete?.(); } };

    if (!sideData?.elementPlacement || !sideData?.zonePlacement) {
      console.warn('⚠️ No placement data, skipping preview refresh');
      done();
      return;
    }

    // mediaPosition null now means "auto-fit/centered default" → top-anchor via vertical_align
    // below. Do NOT early-return on null, or the refresh is skipped and the stale (possibly
    // centered) preview lingers. The line-1490 guard already handled genuinely-missing placement.
    const mediaPosition = this.calculateMediaPosition(sideData.elementPlacement, sideData.zonePlacement);

    const product = this.productList.find((p: any) => String(p.ProductId) === String(productId));
    if (!product) { done(); return; }

    const currentSide = (product as any).Sides?.find((s: any) =>
      (s.Name || s.DisplayName || '').toLowerCase() === sideName.toLowerCase()
    );
    if (!currentSide?.TemplateId) { done(); return; }

    const currentStyle = (product as any).Styles?.find((s: any) => s.ID === (product as any).StyleId);
    if (!currentStyle) { done(); return; }

    let sideImageUrl = currentStyle[currentSide.ImageField || this.imageFieldForSide(currentSide)] || '';
    if (sideImageUrl && !sideImageUrl.startsWith('http')) {
      sideImageUrl = this.masterProductImgBaseURL + sideImageUrl;
    }
    if (!sideImageUrl) sideImageUrl = (product as any).ImageUrl;

    // Use override logo URL (from asset API) if provided, otherwise fall back to global designData
    const designUrl = overrideLogoUrl || this.designData?.designUrl || this.designData?.previewUrl;
    if (!designUrl) { done(); return; }

    let zoneDimensions = '300x300';
    let zoneOffset = '100x100';
    if (currentSide.PrintPlacement) {
      try {
        const pp = typeof currentSide.PrintPlacement === 'string'
          ? JSON.parse(currentSide.PrintPlacement) : currentSide.PrintPlacement;
        if (pp.Width && pp.Height) zoneDimensions = `${pp.Width}x${pp.Height}`;
        if (pp.X !== undefined && pp.Y !== undefined) zoneOffset = `${pp.X}x${pp.Y}`;
      } catch (e) {
        console.warn('Failed to parse PrintPlacement:', e);
      }
    }

    // Only bake media_position when it's a real placement. When null (auto-fit/centered default),
    // omit it so the design top-anchors via product_image_canvas_zone_vertical_align:'top' below.
    const logoClass: any = { url: designUrl };
    if (mediaPosition) logoClass.media_position = mediaPosition;
    const customizationObject = { classes: { logo: logoClass } };

    console.log('🔄 Refreshing preview after editor close with media_position:', mediaPosition);
    this.loadingPreviews.add(product.ProductId);

    // Flatten the transparent product image onto white BEFORE handing it to DH — see
    // ProductImageMatteService for why (DH has no background/matte param of its own).
    this.productImageMatteService.getFlattenedProductImageUrl(sideImageUrl).subscribe(flattenedSideImageUrl => {
    (window as any).DSHDLib.getVariableTemplatePreviewURL(
      {
        template_id: parseInt(currentSide.TemplateId),
        customizations: customizationObject,
        // REVERTED to 300/500 (original). product_image_canvas_zone_dimensions/offset are pixel
        // coordinates calibrated against product_image_width:500 — changing that value distorts
        // every saved print-zone placement. Resolution fixes belong only in the export-job path's
        // top-level `width` (zone-independent), not here.
        width: 300,
        product_image_url: flattenedSideImageUrl,
        product_image_width: 500,
        product_image_canvas_zone_dimensions: zoneDimensions,
        product_image_canvas_zone_offset: zoneOffset,
        // Only top-anchor when there's no editor-derived placement (that is user intent).
        ...(mediaPosition ? {} : { product_image_canvas_zone_vertical_align: 'top' }),
        fit: 'center'
      },
      (error: any, url: string) => {
        if (error) {
          console.error('❌ Preview refresh error:', error);
          this.loadingPreviews.delete(product.ProductId);
          done();
          return;
        }
        console.log('✅ Preview refreshed after editor close:', url);
        const cacheKey = `${product.ProductId}_${sideName}`;
        // Preload the image BEFORE swapping it in and signaling completion, so the loader stays up
        // until the preview is actually decoded and ready to paint — no blank gap between the
        // loader closing and the new preview appearing ("preview coming late").
        const img = new Image();
        const finish = () => {
          this.generatedPreviews.set(cacheKey, url);
          this.productCurrentImages.set(product.ProductId, url);
          this.loadingPreviews.delete(product.ProductId);
          done();
        };
        img.onload = finish;
        img.onerror = () => {
          // Even if preload fails, still swap in the URL and release the loader (the <img> in the
          // template may still resolve it) — never strand the spinner.
          console.warn('⚠️ Preview image preload failed; using URL anyway:', url);
          finish();
        };
        img.src = url;
      }
    );
    });
  }

  /**
   * Find editor side data for a product (any side).
   * Returns the first matching entry from editorSideData map.
   */
  getEditorSideDataForProduct(productId: string): any {
    for (const [key, value] of this.editorSideData.entries()) {
      if (key.startsWith(`${productId}_`)) {
        return value;
      }
    }
    return null;
  }

  goBackToDesignPreview(): void {
    const prefix = getRoutePrefix(this.router.url);
    this.router.navigate([`${prefix}/design-preview`], {
      queryParams: {
        storeId: this.storeId,
        storeName: this.storeName
      }
    });
  }

  goToUploadDesign(): void {
    const prefix = getRoutePrefix(this.router.url);
    this.router.navigate([`${prefix}/upload-design`], {
      queryParams: {
        storeId: this.storeId || localStorage.getItem('storeId') || '',
        storeName: this.storeName || localStorage.getItem('storeName') || ''
      }
    });
  }

  continueWithSelectedProducts(): void {
    if (this.selectedProductsCount === 0) {
      console.warn('⚠️ No products selected');
      return;
    }

    console.log('📋 Selected product IDs:', Array.from(this.selectedProducts));

    // Re-snapshot every selected product still visible in the current list. The snapshot taken
    // when "Add to build" was clicked (toggleProductSelection -> snapshotForBuild) goes stale the
    // moment the user checks/unchecks another colorway afterward on the same card — toggleColorwayStaged
    // updates the live staged set but not this already-stored snapshot, so a since-unchecked color
    // would otherwise still reach product-color-selection. Re-snapshotting here guarantees the data
    // handed off reflects whatever is actually checked right now. Only a product that's scrolled out
    // of the current filtered list (no longer in productList) falls back to whatever was last stored.
    this.selectedProducts.forEach(productId => {
      const fromList = this.productList.find(p => String(p.ProductId) === productId);
      if (fromList) {
        this.selectedProductsDataMap.set(productId, this.snapshotForBuild(fromList));
      }
    });

    const selectedProductsData = Array.from(this.selectedProducts)
      .map(id => this.selectedProductsDataMap.get(id))
      .filter(p => !!p);

    console.log('✅ Selected products data:', selectedProductsData);

    if (selectedProductsData.length === 0) {
      console.error('❌ No matching products found!');
      return;
    }

    // Show dialog to collect project titles for each product
    this.showProjectTitlesDialog(selectedProductsData);
  }

  showProjectTitlesDialog(selectedProductsData: any[]): void {
    // Create dialog content with input fields for each product
    // Mark products that already have editor side data as disabled
    const dialogData = {
      title: 'Enter Project Titles',
      message: 'Please provide a title for each product project:',
      storeId: this.storeId,
      isEditMode: this.stateService.isEditMode(),
      products: selectedProductsData.map(p => {
        const editorEntry = this.getEditorSideDataForProduct(String(p.ProductId));
        const hasEditorData = editorEntry && editorEntry.projectId;
        // Product request mode: use unique default title with PR ID to avoid collisions
        let defaultTitle = `${p.Description}_Design`;
        if (this.isProductRequestMode && this.productRequestData?.productRequestId) {
          defaultTitle = `${p.Description}_PR${this.productRequestData.productRequestId}`;
        }
        return {
          productId: p.ProductId,
          productName: p.Description,
          projectTitle: hasEditorData ? editorEntry.projectTitle : defaultTitle,
          disabled: !!hasEditorData
        };
      })
    };

    const dialogRef = this.dialog.open(ProjectTitlesDialogComponent, {
      width: '600px',
      data: dialogData,
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result.confirmed) {
        // User confirmed, create projects with the provided titles
        const productsWithTitles = selectedProductsData.map((product, index) => ({
          ...product,
          projectTitle: result.projectTitles[index] || `${product.Description}_Design`
        }));

        // Show loader with message and initial progress counter.
        // setPersistentMessage must be called BEFORE show/setProgress so that every
        // subsequent setProgress re-emit carries the message text (setProgress only
        // reads persistentMessage, not the one-off arg passed to show()).
        this.loader.setPersistentMessage(
          'Creating design projects…',
          'Your logos are being applied. This may take a moment.'
        );
        this.loader.show();
        this.loader.setProgress(0, productsWithTitles.length);

        // Create DesignHuddle projects for each selected product
        this.createDesignHuddleProjects(productsWithTitles);
      }
    });
  }

  createDesignHuddleProjects(selectedProductsData: any[]): void {
    console.log('🎨 Creating DesignHuddle projects for selected products...', selectedProductsData);

    const projectsData: any[] = [];

    // Process products sequentially to avoid DesignHuddle SDK concurrency issues
    this.processNextProduct(selectedProductsData, 0, projectsData);
  }

  private processNextProduct(selectedProductsData: any[], index: number, projectsData: any[]): void {
    if (index >= selectedProductsData.length) {
      // All products processed
      this.proceedToColorSelection(projectsData);
      return;
    }

    const product = selectedProductsData[index];
    const totalProducts = selectedProductsData.length;

    console.log(`📦 Processing product ${index + 1}/${totalProducts}: ${product.ProductId}`);

    if (!product.Sides || product.Sides.length === 0) {
      console.error(`❌ Product ${product.ProductId} has no Sides data`);
      projectsData.push({ ...product, Sides: [], error: 'No sides data available' });
      this.loader.setProgress(projectsData.length, totalProducts);
      this.processNextProduct(selectedProductsData, index + 1, projectsData);
      return;
    }

    // Use the currently viewed side's template from the preview maps
    const currentTemplateIdFromMap = this.productTemplateIds.get(String(product.ProductId));
    const currentSideNameFromMap = this.productSideNames.get(String(product.ProductId));
    let sideWithTemplate: any;
    if (currentTemplateIdFromMap && currentSideNameFromMap) {
      sideWithTemplate = product.Sides.find((s: any) => {
        const name = (s.Name || s.DisplayName || '').toLowerCase();
        return name === currentSideNameFromMap.toLowerCase() && s.TemplateId;
      });
    }
    if (!sideWithTemplate) {
      sideWithTemplate = product.Sides.find((s: any) => s.TemplateId);
    }
    // Carry through whichever print-location the user explicitly picked on the card for this
    // side (see applySelectedLocation) — otherwise the DesignHuddle project would always get
    // built against the side's default location, silently discarding the location chosen.
    if (sideWithTemplate) {
      sideWithTemplate = this.applySelectedLocation(product, sideWithTemplate);
    }
    if (!sideWithTemplate) {
      console.error(`❌ Product ${product.ProductId} has no side with TemplateId`);
      projectsData.push({
        ...product,
        Sides: product.Sides.map((s: any) => ({
          SideName: s.Name || s.DisplayName || 'unknown',
          InkSoftLocationName: s.InkSoftLocationName || null,
          ProjectId: null, TemplateId: null, DownloadUrl: null,
          ProjectName: `${product.projectTitle || product.Description}`,
          customizationHash: null, error: 'No template assigned'
        })),
        error: 'No template assigned to any side'
      });
      this.loader.setProgress(projectsData.length, totalProducts);
      this.processNextProduct(selectedProductsData, index + 1, projectsData);
      return;
    }

    const projectTitle = product.projectTitle || product.Description;
    const activeSideName = (sideWithTemplate.Name || sideWithTemplate.DisplayName || 'front').toLowerCase();
    const editorKey = `${product.ProductId}_${activeSideName}`;
    const existingEditorData = this.editorSideData.get(editorKey);

    // If this side already has a project from the editor, skip project creation
    if (existingEditorData && existingEditorData.projectId) {
      console.log(`✅ Reusing existing editor project for ${editorKey}:`, existingEditorData.projectId);
      projectsData.push({
        ...product,
        ProjectId: existingEditorData.projectId,
        ProjectTitle: projectTitle,
        Sides: product.Sides.map((s: any) => {
          const sName = (s.Name || s.DisplayName || 'unknown').toLowerCase();
          const sideEditorData = this.editorSideData.get(`${product.ProductId}_${sName}`);
          const es = this.applySelectedLocation(product, s);
          return {
            SideName: s.Name || s.DisplayName || 'unknown',
            InkSoftLocationName: s.InkSoftLocationName || null,
            DownloadUrl: null, ThumbnailUrl: null,
            TemplateId: es.TemplateId || null,
            PrintPlacement: es.PrintPlacement || null,
            ProjectId: sideEditorData?.projectId || null,
            elementPlacement: sideEditorData?.elementPlacement || null,
            zonePlacement: sideEditorData?.zonePlacement || null
          };
        })
      });
      this.loader.setProgress(projectsData.length, totalProducts);
      this.processNextProduct(selectedProductsData, index + 1, projectsData);
      return;
    }

    const designUrl = this.designData?.designUrl || this.designData?.previewUrl || '';
    const customizationObject = { classes: { logo: { url: designUrl } } };
    const templateId = parseInt(sideWithTemplate.TemplateId);

    if (typeof (window as any).DSHDLib === 'undefined') {
      console.error('❌ DesignHuddle SDK not available');
      projectsData.push({
        ...product,
        Sides: product.Sides.map((s: any) => ({
          SideName: s.Name || s.DisplayName || 'unknown',
          InkSoftLocationName: s.InkSoftLocationName || null,
          ProjectId: null, TemplateId: this.applySelectedLocation(product, s).TemplateId || null,
          DownloadUrl: null, ProjectName: projectTitle,
          error: 'DesignHuddle SDK not loaded'
        })),
        error: 'DesignHuddle SDK not loaded'
      });
      this.loader.setProgress(projectsData.length, totalProducts);
      this.processNextProduct(selectedProductsData, index + 1, projectsData);
      return;
    }

    console.log('📋 Creating project with payload:', { template_id: templateId, project_title: projectTitle });

    (window as any).DSHDLib.createProject(
      { template_id: templateId, project_title: toDesignHuddleProjectTitle(projectTitle), customizations: customizationObject },
      (error: any, projectData: any) => {
        if (error) {
          console.error(`❌ Error creating project for ${product.ProductId}:`, error);
          projectsData.push({
            ...product, ProjectId: null, ProjectTitle: projectTitle,
            Customizations: customizationObject,
            Sides: product.Sides.map((s: any) => ({
              SideName: s.Name || s.DisplayName || 'unknown',
              InkSoftLocationName: s.InkSoftLocationName || null,
              ProjectId: null, TemplateId: this.applySelectedLocation(product, s).TemplateId || null,
              DownloadUrl: null, ProjectName: projectTitle,
              error: 'Failed to create project'
            })),
            error: 'Failed to create project'
          });
          this.loader.setProgress(projectsData.length, totalProducts);
          // Process next product even on error
          this.processNextProduct(selectedProductsData, index + 1, projectsData);
        } else {
          console.log(`✅ Project created for ${product.ProductId}:`, projectData.project_id);
          const projectId = projectData.project_id;

          this.designHuddleService.getProjectData(projectId).subscribe(
            (metadataResponse: any) => {
              const parsedData = this.parseProjectMetadata(metadataResponse, projectId);
              console.log(`📐 Metadata fetched for project ${projectId}:`, parsedData);

              projectsData.push({
                ...product, ProjectId: projectId, ProjectTitle: projectTitle,
                Customizations: customizationObject,
                Sides: product.Sides.map((s: any) => {
                  const es = this.applySelectedLocation(product, s);
                  return {
                    SideName: s.Name || s.DisplayName || 'unknown',
                    InkSoftLocationName: s.InkSoftLocationName || null,
                    DownloadUrl: null, ThumbnailUrl: null,
                    TemplateId: es.TemplateId || null,
                    PrintPlacement: es.PrintPlacement || null,
                    elementPlacement: parsedData?.elementPlacement || null,
                    zonePlacement: parsedData?.zonePlacement || null
                  };
                })
              });

              console.log(`Progress: ${projectsData.length}/${selectedProductsData.length} products processed`);
              this.loader.setProgress(projectsData.length, totalProducts);
              this.processNextProduct(selectedProductsData, index + 1, projectsData);
            },
            (metadataError: any) => {
              console.warn(`⚠️ Failed to fetch metadata for project ${projectId}:`, metadataError);

              projectsData.push({
                ...product, ProjectId: projectId, ProjectTitle: projectTitle,
                Customizations: customizationObject,
                Sides: product.Sides.map((s: any) => {
                  const es = this.applySelectedLocation(product, s);
                  return {
                    SideName: s.Name || s.DisplayName || 'unknown',
                    InkSoftLocationName: s.InkSoftLocationName || null,
                    DownloadUrl: null, ThumbnailUrl: null,
                    TemplateId: es.TemplateId || null,
                    PrintPlacement: es.PrintPlacement || null,
                    elementPlacement: null, zonePlacement: null
                  };
                })
              });

              console.log(`Progress: ${projectsData.length}/${selectedProductsData.length} products processed`);
              this.loader.setProgress(projectsData.length, totalProducts);
              this.processNextProduct(selectedProductsData, index + 1, projectsData);
            }
          );
        }
      }
    );
  }

  proceedToColorSelection(projectsData: any[]): void {
    console.log('✅ All designs created, proceeding to color selection:', projectsData);

    // Clear persistent message, progress counter, and hide loader
    this.loader.clearPersistentMessage();
    this.loader.clearProgress();
    this.loader.hide();

    // Add selected StyleId, generated preview URL, and current side info to each product data
    const projectsDataWithSelectedStyle = projectsData.map(product => {
      // Get the generated preview URL for this product (with design applied)
      const generatedPreviewUrl = this.productCurrentImages.get(product.ProductId) || product.ImageUrl;

      // Get currently viewed side info from maps
      const currentSideName = this.productSideNames.get(String(product.ProductId)) || 'front';
      let currentSide = product.Sides?.find((s: any) =>
        (s.Name || s.DisplayName || '').toLowerCase() === currentSideName.toLowerCase()
      );
      // Carry the explicitly picked print-location's own zone through too, same as
      // processNextProduct did when it actually built the DesignHuddle project.
      if (currentSide) {
        currentSide = this.applySelectedLocation(product, currentSide);
      }

      return {
        ...product,
        // Lock the color-selection page's uncheckable/default color to the ORIGINAL default the
        // card started with, not whichever color was last clicked while staging others — the
        // DesignHuddle project/template is shared across every staged color (only the garment
        // photo differs per color), so it doesn't matter which color "owns" the project.
        selectedStyleId: product.DefaultStagedStyleId ?? product.StyleId,
        // Every colorway staged on the card, so product-color-selection can pre-check all of
        // them (locked default included) instead of just the single last-active one.
        StagedStyleIds: (product.StagedStyleIds && product.StagedStyleIds.length)
          ? product.StagedStyleIds
          : [product.StyleId],
        PreviewImageUrl: generatedPreviewUrl, // Include the generated preview with design
        hasTextElements: this.currentProjectHasTextElements, // Carry text-element flag to color-selection
        currentSideName: currentSideName,
        currentTemplateId: this.productTemplateIds.get(String(product.ProductId)) || null,
        currentSidePrintPlacement: currentSide?.PrintPlacement || null
      };
    });

    // Store selected products data with project IDs, download URLs, and selected StyleId in state service
    this.stateService.setSelectedProductsForColors(projectsDataWithSelectedStyle);

    // Store design data
    this.stateService.setDesignData(this.designData);
    this.stateService.setDesignDataForProduct(this.designData);

    console.log('✅ Continuing with selected products:', projectsDataWithSelectedStyle);
    console.log('✅ Design data:', this.designData);

    // Navigate to color selection page
    const prefix = getRoutePrefix(this.router.url);
    this.router.navigate([`${prefix}/product-color-selection`], {
      queryParams: {
        storeId: this.storeId,
        storeName: this.storeName
      }
    });
  }

  // Initialize DesignHuddle SDK
  initializeDesignHuddle(): void {
    if (typeof (window as any).DSHDLib !== 'undefined') {
      (window as any).DSHDLib.configure({
        domain: environment.designHuddleDomain,
        client_id: environment.designHuddleClientId,
        guest: true
      });
      console.log('✅ DesignHuddle SDK initialized');
    } else {
      console.warn('⚠️ DesignHuddle SDK not loaded');
    }
  }

  // Load DesignHuddle templates
  loadDesignHuddleTemplates(callback?: () => void): void {
    if (this.designHuddleTemplates.length > 0) {
      if (callback) callback();
      return;
    }

    if (typeof (window as any).DSHDLib === 'undefined') {
      console.error('❌ DesignHuddle SDK not loaded');
      this.loader.hide();
      if (callback) callback();
      return;
    }

    this.isLoadingTemplates = true;
    // limit: 200 — the gallery API defaults to 50 per page; with 100+ size templates the
    // default page misses older template ids and saved side templates fail to resolve
    (window as any).DSHDLib.getTemplates({ primary_template_category_item_id: environment.designHuddleCategoryId, limit: 200 }, (err: any, data: any) => {
      this.isLoadingTemplates = false;
      if (err) {
        console.error('❌ Error loading templates:', err);
        this.loader.hide();
        if (callback) callback();
        return;
      }
      this.designHuddleTemplates = data.items || [];
      console.log('✅ Templates loaded, count:', this.designHuddleTemplates.length);
      if (callback) callback();
    });
  }

  // Generate previews for all products
  generatePreviewsForAllProducts(): void {
    if (!this.designData || (!this.designData.designUrl && !this.designData.previewUrl)) {
      console.warn('⚠️ No design URL available');
      return;
    }

    const designUrl = this.designData.designUrl || this.designData.previewUrl;
    console.log('🎨 Starting preview generation for all products with design:', designUrl);

    // Show loader while generating previews
    this.loader.show();

    this.loadDesignHuddleTemplates(() => {
      let previewsQueued = 0;
      this.productList.forEach(product => {
        const hadPreview = this.loadingPreviews.size;
        this.generatePreviewForProduct(product, designUrl);
        if (this.loadingPreviews.size > hadPreview) {
          previewsQueued++;
        }
      });

      // If no previews were queued, hide the loader immediately
      if (previewsQueued === 0) {
        this.loader.clearPersistentMessage();
        this.loader.hide();
        // In product request mode, still advance — even with no preview we can
        // proceed to color selection (DH editor will handle per-side logos there)
        this.maybeAutoAdvanceForProductRequest();
      }
    });
  }

  // Generate preview for a single product (default/front side)
  generatePreviewForProduct(product: any, designUrl: string): void {
    const productId = product.ProductId;
    const currentImageUrl = this.productCurrentImages.get(productId) || product.ImageUrl;

    if (!product.Sides || product.Sides.length === 0) {
      console.warn('⚠️ No Sides data for product:', productId);
      return;
    }

    console.log('🔄 Generating preview for product:', productId);
    console.log('📦 Product has', product.Sides.length, 'sides');

    // Get current style to find which image field is being displayed.
    // Defensive fallback to the first active style: if product.StyleId ever fails to resolve
    // (e.g. a NULL/unmatched DefaultStyleId), render against the first active style rather than
    // aborting the preview. The warning now only fires when there are genuinely no active styles.
    const currentStyle = product.Styles.find((s: any) => s.ID === product.StyleId)
      || product.Styles[0];
    if (!currentStyle) {
      console.warn('⚠️ Current style not found (no active styles) for product:', product.ProductId);
      return;
    }

    // Find which side by matching image URL to style's image fields
    const sideName = this.getSideNameFromStyle(currentStyle, currentImageUrl);
    const currentSide = product.Sides.find((s: any) =>
      s.Name?.toLowerCase() === sideName.toLowerCase() ||
      s.DisplayName?.toLowerCase() === sideName.toLowerCase()
    );

    if (currentSide && currentSide.TemplateId) {
      // Changing color (toggleColorwayStaged → selectStyleToCustomize → here) must keep
      // rendering against whichever print-location this side has selected, not silently fall
      // back to the side's default — otherwise picking a 2nd/3rd colorway looked like it "forgot"
      // the location and reverted the preview to the first/default one.
      const region = this.regionForSideName((currentSide.Name || currentSide.DisplayName || '').toLowerCase().replace(/[\s_-]+/g, ''));
      const explicitLocationId = this.cardSubLocation[this.sideLocationKey(product, region)];
      const effectiveSide = this.applySelectedLocation(product, currentSide);
      const locationOverridden = explicitLocationId != null && effectiveSide.TemplateId !== currentSide.TemplateId;
      this.loadingPreviews.add(product.ProductId);
      this.generateSidePreview(product, effectiveSide, currentImageUrl, designUrl, sideName, locationOverridden ? explicitLocationId : null);
    }
  }

  // Helper: Get side name from Style object by matching which ImageFilePath field matches the URL
  /**
   * Map a side to its style image field. Side objects from the API expose Name/DisplayName
   * (e.g. "sleeveright" / "Right Sleeve") but NO ImageField, so currentStyle[currentSide.ImageField]
   * was always undefined and fell back to the front product image — the editor/export got the FRONT
   * shirt for a sleeve. Derive the field from the side name (separator-agnostic: "sleeveright",
   * "Right Sleeve", "sleeve_right" all → ImageFilePath_SleeveRight).
   */
  imageFieldForSide(side: any): string {
    const n = (side?.Name || side?.DisplayName || '').toLowerCase().replace(/[\s_-]+/g, '');
    if (n.includes('back')) return 'ImageFilePath_Back';
    if (n.includes('left')) return 'ImageFilePath_SleeveLeft';
    if (n.includes('right')) return 'ImageFilePath_SleeveRight';
    return 'ImageFilePath_Front';
  }

  getSideNameFromStyle(style: any, imageUrl: string): string {
    const urlPath = imageUrl.replace(this.masterProductImgBaseURL, '');

    if (style.ImageFilePath_Front === urlPath) {
      return 'front';
    } else if (style.ImageFilePath_Back === urlPath) {
      return 'back';
    } else if (style.ImageFilePath_SleeveLeft === urlPath) {
      return 'left sleeve';
    } else if (style.ImageFilePath_SleeveRight === urlPath) {
      return 'right sleeve';
    }

    // Fallback: check by URL content
    if (urlPath.includes('/front/')) return 'front';
    if (urlPath.includes('/back/')) return 'back';
    if (urlPath.includes('SleeveLeft')) return 'left_sleeve';
    if (urlPath.includes('SleeveRight')) return 'right_sleeve';

    console.log('📍 Detected side from style:', 'front (default)');
    return 'front'; // Default
  }

  // Generate preview for a specific side. `locationId` is set when regenerating for a non-default
  // print-location chip (see refreshPreviewForLocation) so the result caches under its own key
  // instead of overwriting the side's default-location cache entry.
  generateSidePreview(product: any, side: any, productImageUrl: string, designUrl: string, sideName?: string, locationId?: number | null): void {
    if (!side || !side.TemplateId) {
      this.loadingPreviews.delete(product.ProductId);
      return;
    }

    const numericTemplateId = parseInt(side.TemplateId);

    // Parse PrintPlacement for zone dimensions and offset
    let zoneDimensions = '300x300';
    let zoneOffset = '100x100';
    if (side.PrintPlacement) {
      try {
        const pp = typeof side.PrintPlacement === 'string' ? JSON.parse(side.PrintPlacement) : side.PrintPlacement;
        if (pp.Width && pp.Height) {
          zoneDimensions = `${pp.Width}x${pp.Height}`;
        }
        if (pp.X !== undefined && pp.Y !== undefined) {
          zoneOffset = `${pp.X}x${pp.Y}`;
        }
      } catch (e) {
        console.warn('Failed to parse PrintPlacement:', e);
      }
    }

    // Customization with logo only
    const customizationObject = {
      classes: {
        logo: { url: designUrl }
      }
    };

    // Store template ID and sideName for this product
    this.productTemplateIds.set(String(product.ProductId), numericTemplateId);
    const sideNameToStore = sideName || side.Name || side.DisplayName || 'front';
    this.productSideNames.set(String(product.ProductId), sideNameToStore);

    // Flatten the transparent product image onto white BEFORE handing it to DH — see
    // ProductImageMatteService for why (DH has no background/matte param of its own).
    this.productImageMatteService.getFlattenedProductImageUrl(productImageUrl).subscribe(flattenedProductImageUrl => {
      // Use product_image_url for the selected thumbnail image
      const params: any = {
        template_id: numericTemplateId,
        customizations: customizationObject,
        // REVERTED to 300/500 (original) — see comment on the equivalent revert in
        // product-color-selection.component.ts's generateSidePreview (zone-calibration).
        width: 300,
        product_image_url: flattenedProductImageUrl,
        product_image_width: 500,
        product_image_canvas_zone_dimensions: zoneDimensions,
        product_image_canvas_zone_offset: zoneOffset,
        // Catalog default preview (no user placement yet) → top-anchor the design in the
        // print zone (chest print) instead of DesignHuddle's default centering. `picv` param.
        product_image_canvas_zone_vertical_align: "top",
        fit: "center"
      };

      (window as any).DSHDLib.getVariableTemplatePreviewURL(
        params,
        (error: any, url: string) => {
          this.loadingPreviews.delete(product.ProductId);

          if (error) {
            console.error('getVariableTemplatePreviewURL error:', error);
          } else {
            // Cache the result
            if (sideName) {
              const cacheKey = this.buildPreviewCacheKey(product.ProductId, sideName, locationId);
              this.generatedPreviews.set(cacheKey, url);
            }

            // Update the current image for this product
            this.productCurrentImages.set(product.ProductId, url);
          }

          // Hide loader when all previews are generated
          if (this.loadingPreviews.size === 0) {
            this.loader.clearPersistentMessage();
            this.loader.hide();
            // In product request mode, auto-advance now that previews are ready
            this.maybeAutoAdvanceForProductRequest();
          }
        }
      );
    });
  }

  /**
   * Check whether a raw getProjectData response contains any element with type === "text".
   * Mirrors the same helper in product-color-selection.component.ts — both components
   * need this check independently (they have different context types, so sharing via a
   * service would require significant refactoring for no practical benefit).
   */
  private projectDataHasTextElements(response: any): boolean {
    const root = response?.pages ? response : (response?.data || response);
    const pages: any[] = root?.pages || [];
    for (const page of pages) {
      const elements = page.elements || {};
      for (const elementId of Object.keys(elements)) {
        if (elements[elementId]?.type === 'text') {
          return true;
        }
      }
    }
    return false;
  }

  /**
   * Refresh the master-products preview via the export-job API.
   * Used when the editor project contains text elements, which DSHDLib.getVariableTemplatePreviewURL
   * cannot render client-side.  Mirrors refreshPreviewViaExport in product-color-selection.
   *
   * On completion, the azure_url is stored in generatedPreviews and productCurrentImages
   * so it is visible immediately and persists across thumbnail clicks.
   */
  private refreshPreviewViaExportOnMasterProducts(projectId: string, productId: string, sideName: string): void {
    const product = this.productList.find((p: any) => String(p.ProductId) === String(productId));
    if (!product) {
      console.warn('⚠️ refreshPreviewViaExportOnMasterProducts: product not found', productId);
      return;
    }

    const currentStyle = (product as any).Styles?.find((s: any) => s.ID === (product as any).StyleId);
    if (!currentStyle) return;

    const currentSide = (product as any).Sides?.find((s: any) =>
      (s.Name || s.DisplayName || '').toLowerCase() === sideName.toLowerCase()
    );
    if (!currentSide?.TemplateId) return;

    // Mark this export as in-flight so the Continue button is disabled.
    this.exportPreviewsInFlight++;

    // Resolve product image URL for this side
    let sideImageUrl = currentStyle[currentSide.ImageField || this.imageFieldForSide(currentSide)] || '';
    if (sideImageUrl && !sideImageUrl.startsWith('http')) {
      sideImageUrl = this.masterProductImgBaseURL + sideImageUrl;
    }
    if (!sideImageUrl) sideImageUrl = (product as any).ImageUrl;

    // Parse PrintPlacement for zone dimensions and offset
    let zoneDimensions = '300x300';
    let zoneOffset = '100x100';
    if (currentSide.PrintPlacement) {
      try {
        const pp = typeof currentSide.PrintPlacement === 'string'
          ? JSON.parse(currentSide.PrintPlacement)
          : currentSide.PrintPlacement;
        if (pp.Width && pp.Height) zoneDimensions = `${pp.Width}x${pp.Height}`;
        if (pp.X !== undefined && pp.Y !== undefined) zoneOffset = `${pp.X}x${pp.Y}`;
      } catch (e) {
        console.warn('Failed to parse PrintPlacement for export preview:', e);
      }
    }

    const [zoneW, zoneH] = zoneDimensions.split('x').map(Number);
    const [offX, offY] = zoneOffset.split('x').map(Number);
    const fileName = `${projectId}_${productId}_${sideName}_preview`;
    const exportUrl = `${environment.baseUrl}/api/designhuddle/projects/${projectId}/export-job`;
    const cacheKey = `${productId}_${sideName}`;

    this.loadingPreviews.add(product.ProductId);
    console.log(`📦 Using export-API preview for text-element project: product ${productId} side ${sideName}`);

    // Flatten the transparent product image onto white first — see ProductImageMatteService
    // for why (DH has no background/matte param of its own, confirmed against its API docs).
    this.productImageMatteService.getFlattenedProductImageUrl(sideImageUrl).pipe(
      switchMap(flattenedSideImageUrl => this.http.post<any>(exportUrl, {
        format: 'png',
        fileName: fileName,
        // width (top-level, 1600 — was 800): the final output canvas resolution, safe to bump
        // since it's independent of the zone-calibration coordinate space. product_image.width
        // stays 500 (see comment on the equivalent revert in product-color-selection's
        // refreshPreviewViaExport) — canvas_zone.dimensions/offset are calibrated against it.
        width: 1600,
        product_image: {
          url: flattenedSideImageUrl,
          width: 500,
          canvas_zone: {
            dimensions: `${zoneW}x${zoneH}`,
            offset: `${offX}x${offY}`
          }
        }
      })),
      timeout(30000),
      catchError(err => {
        console.error('❌ Export-based preview failed (master-products)', cacheKey, err);
        return of(null);
      })
    ).subscribe({
      next: (response: any) => {
        const jobId = response?.data?.job_id || '';
        if (!jobId) {
          this.loadingPreviews.delete(product.ProductId);
          this.exportPreviewsInFlight--;
          console.warn('⚠️ No job_id returned from export endpoint');
          return;
        }

        const pollUrl = `${environment.baseUrl}/api/designhuddle/export-job/${projectId}/${jobId}`;
        let attempts = 0;
        const maxAttempts = 30;
        const pollInterval = 2000;

        const poll = () => {
          attempts++;
          this.http.get<any>(pollUrl).pipe(timeout(5000)).subscribe({
            next: (res: any) => {
              const data = res?.data || res;
              const isCompleted = data?.completed === true || data?.status === 'completed';

              if (isCompleted) {
                this.loadingPreviews.delete(product.ProductId);
                this.exportPreviewsInFlight--;
                const azureUrl = data?.azure_url || data?.thumbnail_url || data?.output_url || data?.download_url || '';
                if (azureUrl) {
                  console.log(`✅ Export preview ready (master-products): ${azureUrl}`);
                  this.generatedPreviews.set(cacheKey, azureUrl);
                  this.productCurrentImages.set(product.ProductId, azureUrl);
                } else {
                  console.warn('⚠️ Export completed but no azure_url found for', cacheKey);
                }
              } else if (attempts < maxAttempts) {
                setTimeout(poll, pollInterval);
              } else {
                this.loadingPreviews.delete(product.ProductId);
                this.exportPreviewsInFlight--;
                console.warn('⚠️ Export-based preview poll timed out for', cacheKey);
              }
            },
            error: (err: any) => {
              this.loadingPreviews.delete(product.ProductId);
              this.exportPreviewsInFlight--;
              console.error('❌ Export poll error for', cacheKey, err);
            }
          });
        };

        setTimeout(poll, pollInterval);
      },
      error: () => {
        this.loadingPreviews.delete(product.ProductId);
        this.exportPreviewsInFlight--;
      }
    });
  }
}
